(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4081,2306],{

/***/ 5439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": function() { return /* binding */ mediaDuration; },
/* harmony export */   "LN": function() { return /* binding */ ratingNumberWithDecimal; },
/* harmony export */   "_8": function() { return /* binding */ canWatchLectureVideo; },
/* harmony export */   "dQ": function() { return /* binding */ courseStatusText; },
/* harmony export */   "oK": function() { return /* binding */ errorOfLecture; },
/* harmony export */   "x1": function() { return /* binding */ ogpDataOfCourse; }
/* harmony export */ });
/* unused harmony exports isInValidQuestions, isInValidChapters */
/* harmony import */ var service_course__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11038);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22467);


var mediaDuration = function(media) {
    if (!media) return "--:--";
    if (!media.duration || media.duration === 0) return "--:--";
    return (0,___WEBPACK_IMPORTED_MODULE_1__/* .secondsToHms */ .qt)(media.duration);
};
var ratingNumberWithDecimal = function(rating) {
    if ((0,___WEBPACK_IMPORTED_MODULE_1__/* .isNumber */ .hj)(rating) === false) return "0.0";
    return rating.toFixed(1);
};
var canWatchLectureVideo = function(course, lecture) {
    if (course.is_owner || course.is_purchased) return true;
    return lecture.type === service_course__WEBPACK_IMPORTED_MODULE_0__/* .LecturePaidType.Free */ .ed.Free;
};
// export const lecturesErrors = (lectures: LectureType[]): string[] => {
//   if (!lectures || lectures.length < 3)
//     return ['最低3つのレクチャーを作成してください。'];
// };
var isInValidQuestions = function(questions) {
    if (!questions || questions.length === 0) return false;
    return questions.some(function(question) {
        var ref;
        if (!((ref = question.detail) === null || ref === void 0 ? void 0 : ref.trim())) return true;
        if (question.answers.length !== 4) return true;
        if (question.answers.some(function(answer) {
            var ref;
            return !((ref = answer.detail) === null || ref === void 0 ? void 0 : ref.trim());
        })) return true;
        return false;
    });
};
var isInValidChapters = function(chapters) {
    if (!chapters || chapters.length === 0) return false;
    return chapters.some(function(chapter) {
        var ref;
        if (!((ref = chapter.detail) === null || ref === void 0 ? void 0 : ref.trim())) return true;
        return false;
    });
};
var errorOfLecture = function(lecture) {
    if (!lecture) return "エラーが発生しました";
    if (!lecture.title) {
        return "レクチャーのタイトルを入力してください";
    }
    if (isInValidChapters(lecture.chapters)) {
        return "チャプターの内容を正しく入力してください";
    }
    if (isInValidQuestions(lecture.questions)) {
        return "クイズの内容を正しく入力してください";
    }
    return "";
};
var courseStatusText = function(status) {
    switch(status){
        case service_course__WEBPACK_IMPORTED_MODULE_0__/* .CourseStatus.Draft */ .D4.Draft:
            return "下書き";
        case service_course__WEBPACK_IMPORTED_MODULE_0__/* .CourseStatus.Rejected */ .D4.Rejected:
            return "拒否";
        case service_course__WEBPACK_IMPORTED_MODULE_0__/* .CourseStatus.Submitted */ .D4.Submitted:
            return "申請済み";
        case service_course__WEBPACK_IMPORTED_MODULE_0__/* .CourseStatus.Resubmit */ .D4.Resubmit:
            return "差し戻し";
        case service_course__WEBPACK_IMPORTED_MODULE_0__/* .CourseStatus.Approved */ .D4.Approved:
            return "承認済み";
        default:
            return "";
    }
};
var courseDetailsTitle = function(courseInfo) {
    var user = courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.user;
    return "".concat((courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.title) ? "".concat(courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.title, " | ") : "", " ").concat(user ? "".concat(user === null || user === void 0 ? void 0 : user.name, " (@").concat(user === null || user === void 0 ? void 0 : user.username, ")  | ") : "", " PostPrime | 投資を楽しく学べる！");
};
var ogpDataOfCourse = function(course) {
    var ref;
    if (!course) return {
        imageUrl: "",
        description: "",
        title: ""
    };
    return {
        imageUrl: ((ref = course.thumbnail_image_media) === null || ref === void 0 ? void 0 : ref.url) || "",
        description: (0,___WEBPACK_IMPORTED_MODULE_1__/* .jTrim */ .CL)((0,___WEBPACK_IMPORTED_MODULE_1__/* .removeEmojis */ .gn)((0,___WEBPACK_IMPORTED_MODULE_1__/* .truncateStr */ .bI)(course.description, 150))) || "",
        title: (0,___WEBPACK_IMPORTED_MODULE_1__/* .jTrim */ .CL)((0,___WEBPACK_IMPORTED_MODULE_1__/* .removeEmojis */ .gn)(courseDetailsTitle(course)))
    };
};


/***/ }),

/***/ 36902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useFullscreenStatus; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
function useFullscreenStatus() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isFullscreen = ref[0], setIsFullscreen = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.onfullscreenchange = function() {
            var element = getBrowserFullscreenElementProp();
            if (element) {
                setIsFullscreen(document[element] != null);
            }
        };
        return function() {
            return document.onfullscreenchange = undefined;
        };
    });
    return [
        isFullscreen
    ];
};
var getBrowserFullscreenElementProp = function() {
    if (typeof document.fullscreenElement !== "undefined") {
        return "fullscreenElement";
    } else if (typeof document.mozFullScreenElement !== "undefined") {
        return "mozFullScreenElement";
    } else if (typeof document.msFullscreenElement !== "undefined") {
        return "msFullscreenElement";
    } else if (typeof document.webkitFullscreenElement !== "undefined") {
        return "webkitFullscreenElement";
    } else {
        return null;
    }
};


/***/ }),

/***/ 60612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fq": function() { return /* binding */ CHECK_3DS_CODE; },
/* harmony export */   "GQ": function() { return /* binding */ isHavingPlusBenefits; },
/* harmony export */   "If": function() { return /* binding */ isSubbedPrimePlusBefore; },
/* harmony export */   "Vj": function() { return /* binding */ ableToShowSubscribingStatusModal; },
/* harmony export */   "W$": function() { return /* binding */ isPayingPlus; },
/* harmony export */   "WJ": function() { return /* binding */ isRenewPrimeSubStatus; },
/* harmony export */   "_I": function() { return /* binding */ isPayingPrimeSub; },
/* harmony export */   "bG": function() { return /* binding */ isHavingPrimeBenefits; },
/* harmony export */   "bm": function() { return /* binding */ showingPrimeSubPrice; },
/* harmony export */   "r$": function() { return /* binding */ isSubbingPrimeByCoin; },
/* harmony export */   "uj": function() { return /* binding */ getPrimePlusPackageStatus; },
/* harmony export */   "zB": function() { return /* binding */ plusPackageStatusText; }
/* harmony export */ });
/* unused harmony export isAbleToCreatorNewPrimeSub */
/* harmony import */ var common_interfaces_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21694);
/* harmony import */ var service_payment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43827);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22467);



var CHECK_3DS_CODE = "3DS-authentication-complete";
// having plus benefits
var isHavingPlusBenefits = function(creator) {
    var ref;
    if (!creator) return false;
    var primePlusPackStatus = creator === null || creator === void 0 ? void 0 : (ref = creator.option_creator_subscriptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
        return option.optional_type === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .OptionalPackageName.Plus */ .vq.Plus;
    });
    if (!primePlusPackStatus) return false;
    if ((primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "active" || (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "trialing" || (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "canceled") return true;
    if (primePlusPackStatus.ended_at) return primePlusPackStatus.ended_at && new Date(primePlusPackStatus.ended_at) > new Date();
};
var getPrimePlusPackageStatus = function(creator) {
    var ref;
    if (!creator) return null;
    return creator === null || creator === void 0 ? void 0 : (ref = creator.option_creator_subscriptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
        return option.optional_type === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .OptionalPackageName.Plus */ .vq.Plus;
    });
};
// paying for plus benefits
var isPayingPlus = function(creator) {
    var ref;
    if (!creator) return false;
    var primePlusPackStatus = creator === null || creator === void 0 ? void 0 : (ref = creator.option_creator_subscriptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
        return option.optional_type === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .OptionalPackageName.Plus */ .vq.Plus;
    });
    if (!primePlusPackStatus) return false;
    return (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "active" || (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "trialing" || (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "unpaid";
};
var isSubbingPrimeByCoin = function(creator) {
    var ref;
    if (!creator) return false;
    return [
        "web_coin",
        "android_coin",
        "ios_coin"
    ].includes(creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.platform);
};
var isSubbedPrimePlusBefore = function(creator) {
    var ref;
    if (!creator) return false;
    var primePlusPackStatus = creator === null || creator === void 0 ? void 0 : (ref = creator.option_creator_subscriptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
        return option.optional_type === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .OptionalPackageName.Plus */ .vq.Plus;
    });
    if (!primePlusPackStatus) return false;
    return !!(primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.is_subscribed_before);
};
var ableToShowSubscribingStatusModal = function(creator) {
    if (!creator) return false;
    return isHavingPlusBenefits(creator) || isRenewPrimeSubStatus(creator) || isPayingPrimeSub(creator);
};
var plusPackageStatusText = function(primePlusPackStatus) {
    if (!primePlusPackStatus) return "";
    switch(primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status){
        case "active":
            return "登録中";
        case "trialing":
            return "無料体験中";
        case "canceled":
            return "残り".concat((0,___WEBPACK_IMPORTED_MODULE_2__/* .timeUntil */ .LW)(new Date(primePlusPackStatus.ended_at), common_interfaces_api__WEBPACK_IMPORTED_MODULE_0__/* .Language.Ja */ .SQ.Ja));
        default:
            return "";
    }
};
var isRenewPrimeSubStatus = function(creator) {
    var ref;
    if (!creator) return false;
    return (creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status) === "canceled";
};
var isPayingPrimeSub = function(creator) {
    var ref, ref1, ref2;
    if (!creator) return false;
    return (creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status) === "active" || (creator === null || creator === void 0 ? void 0 : (ref1 = creator.creator_subscription) === null || ref1 === void 0 ? void 0 : ref1.status) === "trialing" || (creator === null || creator === void 0 ? void 0 : (ref2 = creator.creator_subscription) === null || ref2 === void 0 ? void 0 : ref2.status) === "unpaid";
};
var isAbleToCreatorNewPrimeSub = function(creator) {
    var ref;
    return !(creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status) || isRenewPrimeSubStatus(creator);
};
var isHavingPrimeBenefits = function(creator) {
    var ref, ref1, ref2;
    if (!creator) return false;
    return (creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status) === "active" || (creator === null || creator === void 0 ? void 0 : (ref1 = creator.creator_subscription) === null || ref1 === void 0 ? void 0 : ref1.status) === "trialing" || (creator === null || creator === void 0 ? void 0 : (ref2 = creator.creator_subscription) === null || ref2 === void 0 ? void 0 : ref2.status) === "canceled";
};
var showingPrimeSubPrice = function(pack, discountByMembershipWebAmount, currentPaymentBy) {
    if (discountByMembershipWebAmount > 0 && (pack === null || pack === void 0 ? void 0 : pack.recurring) === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .WebPricePackageRecurring.Month */ .a5.Month && currentPaymentBy === "coin") {
        return discountByMembershipWebAmount;
    }
    if ((pack === null || pack === void 0 ? void 0 : pack.recurring) === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .WebPricePackageRecurring.Month */ .a5.Month && currentPaymentBy === "coin") {
        return pack === null || pack === void 0 ? void 0 : pack.original_web_amount;
    }
    return pack === null || pack === void 0 ? void 0 : pack.discounted_web_amount;
};


/***/ }),

/***/ 56824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22467);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37975);
/* harmony import */ var _AnswerItemView_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35711);
/* harmony import */ var _AnswerItemView_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_AnswerItemView_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var AnswerItemView = function(param) {
    var type = param.type, answerItem = param.answerItem, onChooseAnswer = param.onChooseAnswer, answerIndex = param.answerIndex;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_AnswerItemView_module_scss__WEBPACK_IMPORTED_MODULE_4___default().answerItem), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, (_AnswerItemView_module_scss__WEBPACK_IMPORTED_MODULE_4___default().isSelected), type === "selected"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, (_AnswerItemView_module_scss__WEBPACK_IMPORTED_MODULE_4___default().isCorrect), type === "correct"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, (_AnswerItemView_module_scss__WEBPACK_IMPORTED_MODULE_4___default().isWrong), type === "wrong"), _obj)),
        onClick: function() {
            return onChooseAnswer && onChooseAnswer(answerItem.id);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_AnswerItemView_module_scss__WEBPACK_IMPORTED_MODULE_4___default().answerText),
                children: [
                    (0,common_utils__WEBPACK_IMPORTED_MODULE_2__/* .isNumber */ .hj)(answerIndex) && "".concat(answerIndex + 1, ". "),
                    answerItem.detail
                ]
            }),
            type === "selected" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_AnswerItemView_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    name: "checked-white",
                    width: 25,
                    height: 25
                })
            }),
            type === "correct" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_AnswerItemView_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    name: "done",
                    width: 18,
                    height: 18
                })
            }),
            type === "wrong" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_AnswerItemView_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    name: "wrong",
                    width: 20,
                    height: 20
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AnswerItemView);


/***/ }),

/***/ 69771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_common_CourseRatingView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89261);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37975);
/* harmony import */ var components_common_RichContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8348);
/* harmony import */ var components_common_UserInfo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92371);
/* harmony import */ var _CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8240);
/* harmony import */ var _CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6__);








var CourseOverview = function(param) {
    var courseInfo = param.courseInfo;
    var ref, ref1;
    if (!courseInfo) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().courseOverview),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().creatorInfoWrapper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_UserInfo__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        user: courseInfo.user,
                        avatarSize: 36,
                        badgeSize: 32
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_CourseRatingView__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        count: (ref = courseInfo.review_summary) === null || ref === void 0 ? void 0 : ref.count,
                        rating: (ref1 = courseInfo.review_summary) === null || ref1 === void 0 ? void 0 : ref1.rating,
                        className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ratingSection)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().courseTitle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blank), !courseInfo.title)),
                children: courseInfo.title ? courseInfo.title : "タイトル"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().categories),
                children: (courseInfo.domains || []).map(function(domain) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().categoryItem),
                        children: domain.name
                    }, "domain-".concat(domain.name));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().infoTitle),
                children: "コースの詳細"
            }),
            courseInfo.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().courseDescription),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_RichContent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    text: courseInfo.description
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blankInfo),
                children: "コースの詳細"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().infoTitle),
                children: "コースの対象者"
            }),
            !courseInfo.target_user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blankInfo),
                children: "どういった方に向けたコースか"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().targetCustomer),
                children: courseInfo.target_user
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().infoTitle),
                children: "コースで学べる事"
            }),
            !courseInfo.benefits || courseInfo.benefits.length === 0 || courseInfo.benefits.length === 1 && !courseInfo.benefits[0] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blankInfo),
                children: "どのようなことを学べるコースか"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().benefits),
                children: (courseInfo.benefits || []).filter(function(benefit) {
                    return !!benefit.trim();
                }).map(function(benefit, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().benefit),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().icon),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    name: "done",
                                    width: 18,
                                    height: 18
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_CourseOverview_module_scss__WEBPACK_IMPORTED_MODULE_6___default().benefitContent),
                                children: benefit
                            })
                        ]
                    }, "benefit-".concat(index));
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseOverview);


/***/ }),

/***/ 2873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ReviewsSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./components/CourseDetails/index.tsx + 7 modules
var CourseDetails = __webpack_require__(10821);
// EXTERNAL MODULE: ./store/global.ts
var global = __webpack_require__(8405);
// EXTERNAL MODULE: ./components/CourseDetails/ReviewsSection/ReviewSection.module.scss
var ReviewSection_module = __webpack_require__(11854);
var ReviewSection_module_default = /*#__PURE__*/__webpack_require__.n(ReviewSection_module);
// EXTERNAL MODULE: ./service/course.ts
var course = __webpack_require__(11038);
// EXTERNAL MODULE: ./components/common/InfiniteScroll/index.tsx
var InfiniteScroll = __webpack_require__(68330);
// EXTERNAL MODULE: ./components/CourseDetails/ReviewsSection/ReviewItem/ReviewItem.module.scss
var ReviewItem_module = __webpack_require__(86013);
var ReviewItem_module_default = /*#__PURE__*/__webpack_require__.n(ReviewItem_module);
// EXTERNAL MODULE: ./components/common/RichContent/index.tsx + 1 modules
var RichContent = __webpack_require__(8348);
// EXTERNAL MODULE: ./components/common/RoundIcon/index.tsx
var RoundIcon = __webpack_require__(10184);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/common/BadgeIcon/index.tsx
var BadgeIcon = __webpack_require__(85650);
// EXTERNAL MODULE: ./store/timeline.ts
var timeline = __webpack_require__(12800);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./components/common/Icon/index.tsx
var Icon = __webpack_require__(37975);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Rating/Rating.js + 2 modules
var Rating = __webpack_require__(46720);
;// CONCATENATED MODULE: ./components/CourseDetails/ReviewsSection/ReviewItem/index.tsx














function ReviewItem(param) {
    var reviewItem = param.reviewItem;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,react.useState)((ref = reviewItem.user) === null || ref === void 0 ? void 0 : ref.is_followed), isFollowed = ref7[0], setIsFollowed = ref7[1];
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    (0,react.useEffect)(function() {
        var ref;
        setIsFollowed((ref = reviewItem.user) === null || ref === void 0 ? void 0 : ref.is_followed);
    }, [
        (ref1 = reviewItem.user) === null || ref1 === void 0 ? void 0 : ref1.is_followed
    ]);
    var handleFollowClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(userId, isFollowed) {
            var action;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!currentUser) {
                            _ctx.next = 7;
                            break;
                        }
                        action = isFollowed ? "unfollow" : "follow";
                        if (isFollowed) {
                            setIsFollowed(false);
                        } else {
                            setIsFollowed(true);
                        }
                        _ctx.next = 5;
                        return axios/* default.post */.Z.post("/users/follows", {
                            user_id: userId,
                            action: action
                        });
                    case 5:
                        _ctx.next = 8;
                        break;
                    case 7:
                        {
                            showLogin({});
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFollowClick(userId, isFollowed) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ReviewItem_module_default()).postCommentWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ReviewItem_module_default()).userInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ReviewItem_module_default()).avatar,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundIcon/* default */.Z, {
                            user: reviewItem.user,
                            width: 35,
                            height: 35,
                            enableClick: true,
                            hasRing: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ReviewItem_module_default()).nameJob,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/".concat((ref2 = reviewItem.user) === null || ref2 === void 0 ? void 0 : ref2.username),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ReviewItem_module_default()).userNameText,
                                        children: (ref3 = reviewItem.user) === null || ref3 === void 0 ? void 0 : ref3.name
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                value: reviewItem.rating,
                                readOnly: true,
                                name: "currentUserRating"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ReviewItem_module_default()).badge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeIcon/* default */.Z, {
                            badge: (ref4 = reviewItem.user) === null || ref4 === void 0 ? void 0 : ref4.badge,
                            width: 34,
                            height: 34
                        })
                    }),
                    !isFollowed && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) !== ((ref5 = reviewItem.user) === null || ref5 === void 0 ? void 0 : ref5.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "follow",
                        width: 32,
                        height: 32,
                        isOn: isFollowed,
                        hasOn: true,
                        hasHover: true,
                        onClick: function() {
                            var ref;
                            return handleFollowClick((ref = reviewItem.user) === null || ref === void 0 ? void 0 : ref.id, isFollowed);
                        }
                    })
                ]
            }),
            ((ref6 = reviewItem.comment) === null || ref6 === void 0 ? void 0 : ref6.trim()) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ReviewItem_module_default()).contentBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ReviewItem_module_default()).content,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichContent/* default */.Z, {
                        text: reviewItem.comment
                    })
                })
            })
        ]
    });
}
var MemoizedReviewItem = /*#__PURE__*/ react.memo(ReviewItem);
/* harmony default export */ var ReviewsSection_ReviewItem = (MemoizedReviewItem);

// EXTERNAL MODULE: ./components/common/ProgressRing/index.tsx
var ProgressRing = __webpack_require__(8325);
// EXTERNAL MODULE: ./components/common/Button/index.tsx
var Button = __webpack_require__(98133);
// EXTERNAL MODULE: ./components/common/TextEditor/index.tsx + 1 modules
var TextEditor = __webpack_require__(55646);
// EXTERNAL MODULE: ./components/CourseDetails/ReviewsSection/ReviewCommentBox/ReviewCommentBox.module.scss
var ReviewCommentBox_module = __webpack_require__(85425);
var ReviewCommentBox_module_default = /*#__PURE__*/__webpack_require__.n(ReviewCommentBox_module);
;// CONCATENATED MODULE: ./components/CourseDetails/ReviewsSection/ReviewCommentBox/index.tsx













function ReviewCommentBox(param) {
    var callback = param.callback;
    var charLimit = 300;
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var ref = (0,react.useState)(0), newRating = ref[0], setNewRating = ref[1];
    var ref1 = (0,react.useContext)(CourseDetails/* CourseDetailsContext */.Q), courseInfo = ref1.courseInfo, refetchCourse = ref1.refetchCourse;
    var ref2 = (0,react.useState)(false), postable = ref2[0], setPostable = ref2[1];
    // Text editor
    var ref3 = (0,react.useState)(""), plainText = ref3[0], setPlainText = ref3[1];
    var textLength = (0,react.useMemo)(function() {
        return plainText.length;
    }, [
        plainText
    ]);
    var textEditorRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        setPostable(textLength <= charLimit && newRating > 0);
    }, [
        textLength,
        charLimit,
        newRating
    ]);
    // Make comment
    var ref4 = (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var comment, rating;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        comment = param.comment, rating = param.rating;
                        _ctx.next = 3;
                        return (0,course/* addReview */.N_)({
                            courseId: courseInfo.id,
                            comment: comment,
                            rating: rating
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function() {
            callback && callback();
            refetchCourse();
        },
        onError: function() {
            setSnackbarMessage({
                type: "error",
                text: "エラーが発生しました"
            });
        }
    }), handleAddReview = ref4.mutate, isMakingReview = ref4.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ReviewCommentBox_module_default()).addReviewSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ReviewCommentBox_module_default()).title,
                children: "あなたのレビュー"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ReviewCommentBox_module_default()).addRatingSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                    value: newRating,
                    onChange: function(e, value) {
                        return setNewRating(value);
                    },
                    size: "large",
                    name: "add-rating"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ReviewCommentBox_module_default()).commentBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ReviewCommentBox_module_default()).inputBox,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ReviewCommentBox_module_default()).textInputWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ReviewCommentBox_module_default()).textInput,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEditor/* default */.Z, {
                                    ref: textEditorRef,
                                    setPlainText: setPlainText,
                                    placeholder: "レビューを入力する",
                                    readOnly: false,
                                    initialText: "",
                                    charLimit: charLimit
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ReviewCommentBox_module_default()).footer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ReviewCommentBox_module_default()).rightSide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ReviewCommentBox_module_default()).progress,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressRing/* default */.Z, {
                                        radius: 22,
                                        current: textLength,
                                        total: charLimit
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ReviewCommentBox_module_default()).addReviewButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    disabled: !postable,
                    onClick: function() {
                        var ref;
                        handleAddReview({
                            comment: ((ref = textEditorRef.current) === null || ref === void 0 ? void 0 : ref.getContent()) || "",
                            rating: newRating
                        });
                    },
                    text: "レビューを保存する",
                    isLoading: isMakingReview
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./common/utils/course.ts
var utils_course = __webpack_require__(5439);
;// CONCATENATED MODULE: ./components/CourseDetails/ReviewsSection/index.tsx

















var ReviewSection = function() {
    var ref, ref1, ref2, ref3, ref4;
    var courseInfo = (0,react.useContext)(CourseDetails/* CourseDetailsContext */.Q).courseInfo;
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var ref5 = (0,react.useState)(), currentReview = ref5[0], setCurrentReview = ref5[1];
    var ref6 = (0,es.useInfiniteQuery)([
        "getReviews",
        (ref = courseInfo.id) === null || ref === void 0 ? void 0 : ref.toString()
    ], function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _pageParam, pageParam;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 0 : _pageParam;
                        _ctx.next = 3;
                        return (0,course/* getReviews */.Jh)({
                            courseId: courseInfo.id,
                            lastId: pageParam
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        getNextPageParam: function(lastPage) {
            var ref;
            var reviews = (lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.reviews) || [];
            if (reviews && reviews.length > 0) {
                var lastRv = reviews[reviews.length - 1];
                return lastRv.id;
            }
        },
        onSuccess: function(data) {
            var ref;
            var newReview = (ref = data.pages[0].data) === null || ref === void 0 ? void 0 : ref.review;
            if (newReview && (!currentReview || (currentReview === null || currentReview === void 0 ? void 0 : currentReview.id) !== newReview.id)) {
                setCurrentReview(newReview);
            }
        },
        enabled: isAuthInit,
        refetchOnWindowFocus: false
    }), data = ref6.data, fetchNextPage = ref6.fetchNextPage, isFetchingNextPage = ref6.isFetchingNextPage, refetch = ref6.refetch;
    var pages = data === null || data === void 0 ? void 0 : data.pages;
    var reviewItems = (0,react.useMemo)(function() {
        return pages ? pages.reduce(function(curr, page) {
            var ref;
            var rvs = ((ref = page.data) === null || ref === void 0 ? void 0 : ref.reviews) || [];
            return curr.concat(rvs);
        }, []) : [];
    }, [
        pages
    ]);
    var ratingsCount = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref = courseInfo.review_summary) === null || ref === void 0 ? void 0 : (ref1 = ref.ratings) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(curr, r) {
            return curr + r.count;
        }, 0);
    }, [
        (ref1 = courseInfo.review_summary) === null || ref1 === void 0 ? void 0 : ref1.ratings
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ReviewSection_module_default()).reviewSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ReviewSection_module_default()).courseRatingSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ReviewSection_module_default()).ratingSummary,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ReviewSection_module_default()).ratingNumber,
                                children: (0,utils_course/* ratingNumberWithDecimal */.LN)((ref2 = courseInfo.review_summary) === null || ref2 === void 0 ? void 0 : ref2.rating)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                readOnly: true,
                                value: ((ref3 = courseInfo.review_summary) === null || ref3 === void 0 ? void 0 : ref3.rating) || 0,
                                size: "large",
                                name: "course-rating"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ReviewSection_module_default()).reviewsCount,
                                children: [
                                    (ref4 = courseInfo.review_summary) === null || ref4 === void 0 ? void 0 : ref4.count,
                                    "件"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ReviewSection_module_default()).ratingDetailsSection,
                        children: [
                            5,
                            4,
                            3,
                            2,
                            1
                        ].map(function(rating) {
                            var ref, ref1, ref2;
                            var count = ((ref2 = (ref = courseInfo.review_summary) === null || ref === void 0 ? void 0 : (ref1 = ref.ratings) === null || ref1 === void 0 ? void 0 : ref1.find(function(r) {
                                return r.rating === rating;
                            })) === null || ref2 === void 0 ? void 0 : ref2.count) || 0;
                            var offWithPercent = ratingsCount === 0 ? 100 : Math.floor(100 - count / ratingsCount * 100);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ReviewSection_module_default()).ratingDetailItem,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (ReviewSection_module_default()).rating,
                                        children: rating
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ReviewSection_module_default()).progressBar,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()((ReviewSection_module_default()).offOverlay, (0,_define_property/* default */.Z)({}, (ReviewSection_module_default()).fullWidth, offWithPercent === 100)),
                                            style: {
                                                width: "".concat(offWithPercent, "%")
                                            }
                                        })
                                    })
                                ]
                            }, "rating-".concat(rating));
                        })
                    })
                ]
            }),
            !courseInfo.is_owner && courseInfo.is_purchased && !courseInfo.review && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ReviewSection_module_default()).addReviewBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewCommentBox, {
                    callback: function() {
                        setTimeout(function() {
                            void refetch();
                        }, 500);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ReviewSection_module_default()).reviewsListWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ReviewSection_module_default()).reviewsListTitle,
                        children: "全てのレビュー"
                    }),
                    reviewItems.length === 0 && !currentReview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ReviewSection_module_default()).empty,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                name: "empty",
                                width: 96,
                                height: 96
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "レビューはありません"
                            })
                        ]
                    }),
                    currentReview && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection_ReviewItem, {
                        reviewItem: currentReview
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                        fetchNextPage: fetchNextPage,
                        isLoading: isFetchingNextPage,
                        children: reviewItems.map(function(rv, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection_ReviewItem, {
                                reviewItem: rv
                            }, "review-".concat(index));
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ReviewsSection = (ReviewSection);


/***/ }),

/***/ 11358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ViewLectureVideoPlayer; }
});

// UNUSED EXPORTS: AutoplayThreshold

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-player/lazy/index.js
var lazy = __webpack_require__(56310);
var lazy_default = /*#__PURE__*/__webpack_require__.n(lazy);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Slider/Slider.js + 1 modules
var Slider = __webpack_require__(59122);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
// EXTERNAL MODULE: ./components/common/Icon/index.tsx
var Icon = __webpack_require__(37975);
// EXTERNAL MODULE: ./components/CourseDetails/ViewLectureVideoPlayer/ViewLectureVideoPlayer.module.scss
var ViewLectureVideoPlayer_module = __webpack_require__(53637);
var ViewLectureVideoPlayer_module_default = /*#__PURE__*/__webpack_require__.n(ViewLectureVideoPlayer_module);
// EXTERNAL MODULE: ./service/course.ts
var course = __webpack_require__(11038);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/common/Button/index.tsx
var Button = __webpack_require__(98133);
// EXTERNAL MODULE: ./components/common/LinkButton/index.tsx
var LinkButton = __webpack_require__(22396);
// EXTERNAL MODULE: ./components/CourseDetails/index.tsx + 7 modules
var CourseDetails = __webpack_require__(10821);
// EXTERNAL MODULE: ./store/global.ts
var global = __webpack_require__(8405);
// EXTERNAL MODULE: ./components/CourseDetails/ViewLectureVideoPlayer/PlayerRateOptions/PlayerRateOptions.module.scss
var PlayerRateOptions_module = __webpack_require__(18685);
var PlayerRateOptions_module_default = /*#__PURE__*/__webpack_require__.n(PlayerRateOptions_module);
;// CONCATENATED MODULE: ./components/CourseDetails/ViewLectureVideoPlayer/PlayerRateOptions/index.tsx




var PlayerRateOptions = function(param) {
    var playbackRate = param.playbackRate, setPlaybackRate = param.setPlaybackRate;
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PlayerRateOptions_module_default()).speedCtrl,
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PlayerRateOptions_module_default()).speedCtrlOptions,
                children: utils/* ALL_PLAYER_RATES_COURSE.map */.IO.map(function(rate, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            if (!currentAuth) {
                                showLogin({});
                                return;
                            }
                            setPlaybackRate(rate);
                        },
                        className: (PlayerRateOptions_module_default()).text,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (PlayerRateOptions_module_default()).content,
                            children: [
                                rate,
                                "x"
                            ]
                        })
                    }, "option-".concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PlayerRateOptions_module_default()).speedBtn,
                children: [
                    playbackRate,
                    "x"
                ]
            })
        ]
    });
};
/* harmony default export */ var ViewLectureVideoPlayer_PlayerRateOptions = (PlayerRateOptions);

// EXTERNAL MODULE: ./node_modules/@rooks/use-fullscreen/lib/index.esm.js + 1 modules
var index_esm = __webpack_require__(94850);
// EXTERNAL MODULE: ./common/utils/fullscreen.ts
var fullscreen = __webpack_require__(36902);
// EXTERNAL MODULE: ./store/timeline.ts
var timeline = __webpack_require__(12800);
;// CONCATENATED MODULE: ./components/CourseDetails/ViewLectureVideoPlayer/index.tsx












// import useGlobalStore from 'store/global';











var AutoplayThreshold;
(function(AutoplayThreshold) {
    AutoplayThreshold[AutoplayThreshold["Center"] = 0] = "Center";
    AutoplayThreshold[AutoplayThreshold["Top"] = 1] = "Top";
})(AutoplayThreshold || (AutoplayThreshold = {}));
function ViewLectureVideoPlayer(param) {
    var lecture = param.lecture, _isPreview = param.isPreview, isPreview = _isPreview === void 0 ? false : _isPreview;
    var ref, ref1, ref2;
    // const setSnackbarMessage = useGlobalStore(
    //   (state) => state.setSnackbarMessage
    // );
    var timebarRef = (0,react.useRef)(null);
    var controlMediaRef = (0,react.useRef)(null);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,timeline/* default */.ZP)(function(state) {
        return [
            state.activeAudioPlayer,
            state.setActiveAudioPlayer, 
        ];
    }), 2), activeAudioPlayer = ref3[0], setActiveAudioPlayer = ref3[1];
    var ref4 = (0,react.useContext)(CourseDetails/* CourseDetailsContext */.Q), setOpenQuestionAnswerDialog = ref4.setOpenQuestionAnswerDialog, courseInfo = ref4.courseInfo, setCurrentLecture = ref4.setCurrentLecture, viewdLectureIds = ref4.viewdLectureIds, setViewedLectureIds = ref4.setViewedLectureIds, setOpenCoursePaywall = ref4.setOpenCoursePaywall;
    var ref5 = (0,index_esm/* default */.Z)(), toggleFullscreen = ref5.toggle, isFullscreen = ref5.isFullscreen;
    var isMobileScreen = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var ref6 = (0,react.useState)(false), isMounted = ref6[0], setIsMounted = ref6[1];
    var playerRef = (0,react.useRef)(null);
    var playerWrapperRef = (0,react.useRef)(null);
    var ref7 = (0,react.useState)(true), muted = ref7[0], setMuted = ref7[1];
    var ref8 = (0,react.useState)(1), playbackRate = ref8[0], setPlaybackRate = ref8[1];
    var ref9 = (0,react.useState)(1), volume = ref9[0], setVolume = ref9[1];
    var ref10 = (0,react.useState)(0), timebarVal = ref10[0], setTimebarVal = ref10[1];
    var ref11 = (0,react.useState)(true), playing = ref11[0], setPlaying = ref11[1];
    var ref12 = (0,react.useState)(0), playedSeconds = ref12[0], setPlayedSeconds = ref12[1];
    var ref13 = (0,react.useState)(0), duration = ref13[0], setDuration = ref13[1];
    var ref14 = (0,react.useState)(false), hasEnded = ref14[0], setHasEnded = ref14[1];
    var ref15 = (0,react.useState)(-1), lastClickTime = ref15[0], setLastClickTime = ref15[1];
    var ref16 = (0,react.useState)(false), isReady = ref16[0], setIsReady = ref16[1];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,fullscreen/* default */.Z)(), 1), isFullScreenBrowser = ref17[0];
    var increaseViewCount = (0,react.useCallback)(function() {
        if (isPreview) return;
        (0,course/* increaseLectureViewCount */.ls)({
            courseId: courseInfo.id,
            lectureId: lecture.id
        });
        setViewedLectureIds(function(ids) {
            if (ids.includes(lecture.id)) return ids;
            return (0,_to_consumable_array/* default */.Z)(ids).concat([
                lecture.id
            ]);
        });
    }, [
        courseInfo.id,
        isPreview,
        lecture.id,
        setViewedLectureIds
    ]);
    (0,react.useEffect)(function() {
        setIsMounted(true);
    }, []);
    // Stop playing audio when other audio sources starts playing
    // Note: how is this working?? why don't playing and muted become stale values??
    (0,react.useEffect)(function() {
        if ((activeAudioPlayer === null || activeAudioPlayer === void 0 ? void 0 : activeAudioPlayer.playing) && playing && !muted) {
            setMuted(true);
        }
    }, [
        activeAudioPlayer,
        playing,
        muted
    ]);
    var currentLectureIndex = (0,react.useMemo)(function() {
        if (!lecture) return -1;
        return (courseInfo.lectures || []).findIndex(function(lec) {
            return lec.id === (lecture === null || lecture === void 0 ? void 0 : lecture.id);
        });
    }, [
        courseInfo,
        lecture
    ]);
    var lectureVideoUrl = (0,react.useMemo)(function() {
        return "".concat(lecture.lecture_media.url, "?token=").concat(lecture.token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lecture.id
    ]);
    // Rewind and fast forward with
    // - positivie skipTime means fast forward
    // - negative skipTime means rewind
    var handleTimeSkip = (0,react.useCallback)(function(skipTime) {
        if (!playerRef.current) return;
        if (skipTime < 0 && !isPreview) {
            increaseViewCount();
        }
        var newTime = playedSeconds + skipTime;
        if (newTime > duration) newTime = duration - 1;
        if (newTime < 0) newTime = 0;
        setPlayedSeconds(newTime);
        playerRef.current.seekTo(newTime, "seconds");
        setTimeout(function() {
            if (newTime === duration) {
                setHasEnded(true);
            }
        }, 500);
    }, [
        duration,
        increaseViewCount,
        isPreview,
        playedSeconds
    ]);
    // Media control overlay
    var mediaControlBtn = (0,react.useMemo)(function() {
        var btn;
        if (hasEnded) {
            btn = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        } else if (!playing) {
            btn = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ViewLectureVideoPlayer_module_default()).playWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ViewLectureVideoPlayer_module_default()).skipBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "play-rewind",
                            height: 50,
                            width: 50,
                            onClick: function() {
                                return handleTimeSkip(-15);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ViewLectureVideoPlayer_module_default()).centerBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "play",
                            width: 96,
                            height: 96,
                            onClick: function() {
                                return setPlaying(true);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ViewLectureVideoPlayer_module_default()).skipBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "play-forward",
                            height: 50,
                            width: 50,
                            onClick: function() {
                                return handleTimeSkip(15);
                            }
                        })
                    })
                ]
            });
        } else if (playing) {
            btn = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((ViewLectureVideoPlayer_module_default()).playWrapper, (ViewLectureVideoPlayer_module_default()).pauseBtn),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ViewLectureVideoPlayer_module_default()).skipBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "play-rewind",
                            height: 50,
                            width: 50,
                            onClick: function() {
                                return handleTimeSkip(-15);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ViewLectureVideoPlayer_module_default()).centerBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "pause",
                            width: 96,
                            height: 96,
                            onClick: function() {
                                return setPlaying(false);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ViewLectureVideoPlayer_module_default()).skipBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "play-forward",
                            height: 50,
                            width: 50,
                            onClick: function() {
                                return handleTimeSkip(15);
                            }
                        })
                    })
                ]
            });
        }
        return btn;
    }, [
        handleTimeSkip,
        hasEnded,
        playing
    ]);
    var handleSpeakerBtnClick = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        setMuted(function(muted) {
            return !muted;
        });
        if (playing && muted) {
            setActiveAudioPlayer("lecture", false);
        }
    }, [
        muted,
        playing,
        setActiveAudioPlayer
    ]);
    var handleClickFullscreen = function(e) {
        var ref, ref1;
        e.stopPropagation();
        try {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (document.exitFullscreen && document.mozFullScreen) {
                void document.exitFullscreen();
            }
        // eslint-disable-next-line no-empty
        } catch (error) {}
        if (!isMobileScreen) {
            void toggleFullscreen(playerWrapperRef.current);
            return;
        }
        /* eslint-disable @typescript-eslint/ban-ts-comment */ // @ts-ignore
        var elem = (ref1 = (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.wrapper) === null || ref1 === void 0 ? void 0 : ref1.querySelector("video");
        // @ts-ignore
        if (elem && elem.webkitEnterFullScreen) {
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            elem.webkitEnterFullScreen();
        } else void toggleFullscreen(playerWrapperRef.current);
    /* eslint-enable @typescript-eslint/ban-ts-comment */ };
    // Volume
    var handleVolumeChange = (0,react.useCallback)(function(e, newVolume) {
        e.stopPropagation();
        if (!(0,utils/* isNumber */.hj)(newVolume) || Array.isArray(newVolume)) {
            newVolume = 0.5;
        }
        if (newVolume < 0.025) {
            setMuted(true);
        } else {
            setMuted(false);
            setVolume(Number(newVolume));
            if (playing) {
                setActiveAudioPlayer("lecture", false);
            }
        }
    }, [
        playing,
        setActiveAudioPlayer
    ]);
    // Timebar
    var handleTimebarChange = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        if (!playerRef.current) return;
        var newTimebarVal = Number(e.target.value);
        playerRef.current.seekTo(newTimebarVal, "fraction");
        setTimebarVal(newTimebarVal);
        setPlayedSeconds(newTimebarVal * duration);
        setTimeout(function() {
            // setPlaying(true);
            if (newTimebarVal === 1) {
                setHasEnded(true);
            }
        }, 500);
    }, [
        duration
    ]);
    (0,react.useEffect)(function() {
        setTimebarVal(duration === 0 ? 0 : playedSeconds / duration);
    }, [
        playedSeconds,
        setTimebarVal,
        duration
    ]);
    var handleChangeChapter = function(position) {
        if (!playerRef.current) return;
        playerRef.current.seekTo(position, "seconds");
        increaseViewCount();
        setTimeout(function() {
            if (position >= duration) {
                setHasEnded(true);
            }
        }, 500);
    };
    var stopPropagation = function(e) {
        e.stopPropagation();
    };
    var handleOverlayClick = function(e) {
        var ref, ref1;
        stopPropagation(e);
        var selection = window.getSelection();
        if (selection.type != "Range" && !(timebarRef === null || timebarRef === void 0 ? void 0 : (ref = timebarRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target)) && !(controlMediaRef === null || controlMediaRef === void 0 ? void 0 : (ref1 = controlMediaRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(e.target))) {
            setPlaying(function(playing) {
                return !playing;
            });
            if (!playing) {
                increaseViewCount();
                setActiveAudioPlayer("lecture", false);
            }
        }
    };
    var hms = (0,react.useMemo)(function() {
        return duration > 0 && duration >= playedSeconds ? (0,utils/* secondsToHms */.qt)(Math.round(playedSeconds)) : utils/* DEFAULT_TIME_HMS */.pr;
    }, [
        duration,
        playedSeconds
    ]);
    var totalHms = (0,react.useMemo)(function() {
        return (0,utils/* secondsToHms */.qt)(Math.round(duration));
    }, [
        duration
    ]);
    var reactPlayerStyle = (0,react.useMemo)(function() {
        var style;
        if (isFullscreen || isFullScreenBrowser) {
            style = {
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            };
        } else {
            style = {};
        }
        return style;
    }, [
        isFullScreenBrowser,
        isFullscreen
    ]);
    var closeFullScreen = function() {
        if (isFullscreen || isFullScreenBrowser) {
            if (document.exitFullscreen && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (document).mozFullScreen) {
                void document.exitFullscreen();
                return;
            }
            void toggleFullscreen();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: playerWrapperRef,
                className: classnames_default()((ViewLectureVideoPlayer_module_default()).playerWrapper, (0,_define_property/* default */.Z)({}, (ViewLectureVideoPlayer_module_default()).fullscreenVideo, isFullscreen || isFullScreenBrowser)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((lazy_default()), {
                        width: "100%",
                        height: "100%",
                        style: reactPlayerStyle,
                        ref: playerRef,
                        url: lectureVideoUrl,
                        muted: muted,
                        volume: volume,
                        playsinline: true,
                        playing: playing && isReady && isMounted,
                        onError: function() {
                            if (!isReady) return;
                            setTimeout(function() {
                                if (playerRef.current && playedSeconds < 10) {
                                    playerRef.current.seekTo(playedSeconds + 2);
                                }
                            }, 500);
                        },
                        onReady: function() {
                            setIsReady(true);
                            if (!playing) setPlaying(true);
                            if (!viewdLectureIds.includes(lecture.id)) {
                                increaseViewCount();
                            }
                        },
                        onProgress: function(param) {
                            var playedSeconds = param.playedSeconds;
                            setPlayedSeconds(playedSeconds);
                            if (playedSeconds < duration - 1 && hasEnded) {
                                setHasEnded(false);
                            }
                        },
                        onDuration: function(duration) {
                            return setDuration(duration);
                        },
                        onPlay: function() {
                            setHasEnded(false);
                        },
                        playbackRate: playbackRate,
                        onEnded: function() {
                            setHasEnded(true);
                            setPlaying(false);
                        },
                        config: {
                            file: {
                                attributes: {
                                    poster: lecture.lecture_thumbnail_media.url
                                }
                            }
                        }
                    }),
                    hasEnded ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ViewLectureVideoPlayer_module_default()).answerButtonOverlay,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ViewLectureVideoPlayer_module_default()).endOfLectureTitle,
                                children: "レクチャーが終了しました"
                            }),
                            ((ref = lecture.questions) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ViewLectureVideoPlayer_module_default()).answerDescription,
                                children: "クリエイターのクイズに解答しよう！"
                            }),
                            ((ref1 = lecture.questions) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ViewLectureVideoPlayer_module_default()).answerButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    text: currentLectureIndex < courseInfo.lectures.length - 1 ? "クイズに解答して次のレクチャーへ" : "クイズに解答する",
                                    onClick: function() {
                                        setOpenQuestionAnswerDialog(true);
                                        closeFullScreen();
                                    }
                                })
                            }),
                            ((ref2 = lecture.questions) === null || ref2 === void 0 ? void 0 : ref2.length) === 0 && currentLectureIndex < courseInfo.lectures.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ViewLectureVideoPlayer_module_default()).answerButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    text: "次のレクチャーへ",
                                    onClick: function() {
                                        if (currentLectureIndex >= courseInfo.lectures.length - 1) return;
                                        var newLectureIndex = currentLectureIndex + 1;
                                        if (isPreview) {
                                            setCurrentLecture(courseInfo.lectures[currentLectureIndex + 1]);
                                            return;
                                        }
                                        var newLecture = courseInfo.lectures[newLectureIndex];
                                        if (newLecture.type === course/* LecturePaidType.Free */.ed.Free) {
                                            setCurrentLecture(newLecture);
                                            return;
                                        }
                                        // if can watch
                                        if (courseInfo.is_owner || courseInfo.is_purchased) {
                                            setCurrentLecture(newLecture);
                                        } else {
                                            // if can't watch => open paywall
                                            closeFullScreen();
                                            setOpenCoursePaywall && setOpenCoursePaywall(true);
                                            return;
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ViewLectureVideoPlayer_module_default()).rewindButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* default */.Z, {
                                    text: "もう一度動画を見る",
                                    onClick: function() {
                                        setPlaying(true);
                                        increaseViewCount();
                                    }
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: handleOverlayClick,
                        className: classnames_default()((ViewLectureVideoPlayer_module_default()).playerOverlay, (0,_define_property/* default */.Z)({}, (ViewLectureVideoPlayer_module_default()).fullscreen, isFullscreen || isFullScreenBrowser)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ViewLectureVideoPlayer_module_default()).mediaControlBtn,
                                ref: controlMediaRef,
                                children: mediaControlBtn
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((ViewLectureVideoPlayer_module_default()).leftCorner, (0,_define_property/* default */.Z)({}, (ViewLectureVideoPlayer_module_default()).mobileCtrlLeftCorner, isMobileScreen)),
                                children: [
                                    duration > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ViewLectureVideoPlayer_module_default()).playTime,
                                        children: [
                                            hms,
                                            " / ",
                                            totalHms
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ViewLectureVideoPlayer_module_default()).timebar,
                                        ref: timebarRef,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "range",
                                            min: 0,
                                            max: 1,
                                            step: 0.025,
                                            value: timebarVal,
                                            style: {
                                                background: "linear-gradient(to right, #fff 0%, #fff ".concat(timebarVal * 100, "%, #aeaeae ").concat(timebarVal * 100, "%, #aeaeae 100%)")
                                            },
                                            onChange: handleTimebarChange,
                                            className: (ViewLectureVideoPlayer_module_default()).sliderTime,
                                            onMouseDown: function() {
                                                setLastClickTime(timebarVal);
                                            },
                                            onMouseUp: function() {
                                                // call event increase view count
                                                if (lastClickTime > timebarVal) {
                                                    increaseViewCount();
                                                }
                                                setLastClickTime(-1);
                                            }
                                        }, "video-time-slider-".concat(lecture.lecture_thumbnail_media.media_id))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ViewLectureVideoPlayer_module_default()).rightCorner,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ViewLectureVideoPlayer_module_default()).volumeCtrl,
                                        onClick: stopPropagation,
                                        children: [
                                            !isMobileScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                                                orientation: "vertical",
                                                defaultValue: 1,
                                                min: 0,
                                                max: 1,
                                                step: 0.025,
                                                onChange: handleVolumeChange,
                                                className: (ViewLectureVideoPlayer_module_default()).volumeSlider
                                            }, "video-slider-".concat(lecture.lecture_media.media_id)),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ViewLectureVideoPlayer_module_default()).speakerBtn,
                                                onClick: handleSpeakerBtnClick,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                    name: "speaker",
                                                    width: 26,
                                                    height: 26,
                                                    hasOn: true,
                                                    isOn: !muted
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewLectureVideoPlayer_PlayerRateOptions, {
                                        setPlaybackRate: setPlaybackRate,
                                        playbackRate: playbackRate
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ViewLectureVideoPlayer_module_default()).fullscreenBtn,
                                        onClick: handleClickFullscreen,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                    name: "fullscreen",
                                                    width: 17,
                                                    height: 17
                                                })
                                            }),
                                            !isMobileScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ViewLectureVideoPlayer_module_default()).fullscreenText,
                                                children: isFullscreen ? "全画面を閉じる" : "全画面で見る"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChaptersList, {
                lecture: lecture,
                handleChangeChapter: handleChangeChapter,
                currentPosition: playedSeconds
            })
        ]
    });
};
var ChaptersList = function(param) {
    var lecture = param.lecture, handleChangeChapter = param.handleChangeChapter, currentPosition = param.currentPosition;
    var ref;
    var showNextBack = lecture.chapters.length > 3;
    var chaptersListRef = (0,react.useRef)();
    var setOpenQuestionAnswerDialog = (0,react.useContext)(CourseDetails/* CourseDetailsContext */.Q).setOpenQuestionAnswerDialog;
    var scrollShowMore = function(offset) {
        if (chaptersListRef.current) {
            chaptersListRef.current.scrollLeft += offset;
        }
    };
    if (lecture.chapters.length === 0 && ((ref = lecture.questions) === null || ref === void 0 ? void 0 : ref.length) === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ViewLectureVideoPlayer_module_default()).chaptersListWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ViewLectureVideoPlayer_module_default()).chaptersListHeader,
                children: [
                    "チャプター(",
                    lecture.chapters.length,
                    ")",
                    lecture.questions.length > 0 && "・クイズ(".concat(lecture.questions.length, ")")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ViewLectureVideoPlayer_module_default()).chaptersList,
                ref: chaptersListRef,
                children: [
                    showNextBack && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ViewLectureVideoPlayer_module_default()).backBtn,
                        onClick: function() {
                            scrollShowMore(-300);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "foward-arrow",
                            width: 24,
                            height: 24
                        })
                    }),
                    showNextBack && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ViewLectureVideoPlayer_module_default()).nextBtn,
                        onClick: function() {
                            scrollShowMore(300);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "foward-arrow",
                            width: 24,
                            height: 24
                        })
                    }),
                    (lecture.chapters || []).map(function(chapter, index) {
                        var ref, ref1, ref2, ref3, ref4, ref5;
                        var isCurrentPosition = currentPosition >= chapter.start_position && (index === lecture.chapters.length - 1 || currentPosition < ((ref = lecture.chapters[index + 1]) === null || ref === void 0 ? void 0 : ref.start_position));
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((ViewLectureVideoPlayer_module_default()).chapterItem, (0,_define_property/* default */.Z)({}, (ViewLectureVideoPlayer_module_default()).currentItem, isCurrentPosition)),
                            onClick: function() {
                                return handleChangeChapter(chapter.start_position);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ViewLectureVideoPlayer_module_default()).chapterThumbnail,
                                    children: chapter.thumbnail_media ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: chapter.thumbnail_media.url,
                                        height: (ref1 = chapter.thumbnail_media) === null || ref1 === void 0 ? void 0 : ref1.height,
                                        width: (ref2 = chapter.thumbnail_media) === null || ref2 === void 0 ? void 0 : ref2.width,
                                        alt: chapter.detail || ""
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: (ref3 = lecture.lecture_thumbnail_media) === null || ref3 === void 0 ? void 0 : ref3.url,
                                        height: (ref4 = lecture.lecture_thumbnail_media) === null || ref4 === void 0 ? void 0 : ref4.height,
                                        width: (ref5 = lecture.lecture_thumbnail_media) === null || ref5 === void 0 ? void 0 : ref5.width,
                                        alt: chapter.detail || ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (ViewLectureVideoPlayer_module_default()).chapterStartPosition,
                                    children: (0,utils/* secondsToHms */.qt)(chapter.start_position)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ViewLectureVideoPlayer_module_default()).chapterTitle,
                                    children: chapter.detail
                                })
                            ]
                        }, "".concat(chapter.id, "-").concat(index));
                    }),
                    lecture.questions && lecture.questions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ViewLectureVideoPlayer_module_default()).chapterItem,
                        onClick: function() {
                            return setOpenQuestionAnswerDialog(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ViewLectureVideoPlayer_module_default()).chapterThumbnail,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    name: "quiz",
                                    width: 72,
                                    height: 72
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (ViewLectureVideoPlayer_module_default()).chapterStartPosition,
                                children: "クイズ"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ViewLectureVideoPlayer_module_default()).chapterTitle
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 10821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ CourseDetailsContext; },
  "Z": function() { return /* binding */ components_CourseDetails; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./service/course.ts
var course = __webpack_require__(11038);
// EXTERNAL MODULE: ./components/CourseDetails/CourseDetails.module.scss
var CourseDetails_module = __webpack_require__(58471);
var CourseDetails_module_default = /*#__PURE__*/__webpack_require__.n(CourseDetails_module);
// EXTERNAL MODULE: ./node_modules/react-tabs/esm/index.js + 10 modules
var esm = __webpack_require__(78369);
// EXTERNAL MODULE: ./components/CourseDetails/ViewLectureVideoPlayer/index.tsx + 1 modules
var ViewLectureVideoPlayer = __webpack_require__(11358);
// EXTERNAL MODULE: ./components/CourseDetails/CourseOverview/index.tsx
var CourseOverview = __webpack_require__(69771);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js + 2 modules
var Dialog = __webpack_require__(93579);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
// EXTERNAL MODULE: ./components/common/Button/index.tsx
var Button = __webpack_require__(98133);
// EXTERNAL MODULE: ./components/common/Icon/index.tsx
var Icon = __webpack_require__(37975);
// EXTERNAL MODULE: ./components/CourseDetails/AnswerItemView/index.tsx
var AnswerItemView = __webpack_require__(56824);
// EXTERNAL MODULE: ./components/CourseDetails/QuestionsAnswerDialog/AnswersResult/AnswersResult.module.scss
var AnswersResult_module = __webpack_require__(54959);
var AnswersResult_module_default = /*#__PURE__*/__webpack_require__.n(AnswersResult_module);
;// CONCATENATED MODULE: ./components/CourseDetails/QuestionsAnswerDialog/AnswersResult/index.tsx





var AnswersResult = function() {
    var ref, ref1;
    var ref2 = (0,react.useContext)(CourseDetailsContext), currentLecture = ref2.currentLecture, courseInfo = ref2.courseInfo;
    var currentLectureIndex = (0,react.useMemo)(function() {
        if (!currentLecture) return -1;
        return (courseInfo.lectures || []).findIndex(function(lec) {
            return lec.id === (currentLecture === null || currentLecture === void 0 ? void 0 : currentLecture.id);
        });
    }, [
        courseInfo,
        currentLecture
    ]);
    var correctCount = (0,react.useMemo)(function() {
        var ref;
        if (!currentLecture) return 0;
        return currentLecture === null || currentLecture === void 0 ? void 0 : (ref = currentLecture.questions) === null || ref === void 0 ? void 0 : ref.filter(function(ques) {
            var correctAnswer = ques.answers.find(function(ans) {
                return ans.is_correct;
            });
            return correctAnswer.id === ques.user_answer_id;
        }).length;
    }, [
        currentLecture
    ]);
    if (!currentLecture) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (AnswersResult_module_default()).results,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (AnswersResult_module_default()).title,
                children: [
                    "レクチャー",
                    currentLectureIndex + 1,
                    "の解答結果",
                    "\n",
                    "正解数: ",
                    correctCount,
                    "/",
                    currentLecture === null || currentLecture === void 0 ? void 0 : (ref = currentLecture.questions) === null || ref === void 0 ? void 0 : ref.length
                ]
            }),
            currentLecture === null || currentLecture === void 0 ? void 0 : (ref1 = currentLecture.questions) === null || ref1 === void 0 ? void 0 : ref1.map(function(question, index) {
                var correctAnswer = question.answers.find(function(ans) {
                    return ans.is_correct;
                });
                var userAnswer = question.answers.find(function(ans) {
                    return ans.id === question.user_answer_id;
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (AnswersResult_module_default()).questionResultItem,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (AnswersResult_module_default()).questionDetail,
                            children: [
                                index + 1,
                                ". ",
                                question.detail
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (AnswersResult_module_default()).userAnswer,
                            children: userAnswer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerItemView/* default */.Z, {
                                type: correctAnswer.id === question.user_answer_id ? "correct" : "wrong",
                                answerItem: userAnswer
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (AnswersResult_module_default()).notAnswerYet,
                                children: "まだ解答していない"
                            })
                        }),
                        userAnswer && correctAnswer.id !== question.user_answer_id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (AnswersResult_module_default()).correctAnswer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerItemView/* default */.Z, {
                                answerItem: correctAnswer,
                                type: "correct"
                            })
                        })
                    ]
                }, "".concat(question.id, "-").concat(index));
            })
        ]
    });
};
/* harmony default export */ var QuestionsAnswerDialog_AnswersResult = (AnswersResult);

// EXTERNAL MODULE: ./components/CourseDetails/QuestionsAnswerDialog/QuestionsAnswerDialog.module.scss
var QuestionsAnswerDialog_module = __webpack_require__(78837);
var QuestionsAnswerDialog_module_default = /*#__PURE__*/__webpack_require__.n(QuestionsAnswerDialog_module);
;// CONCATENATED MODULE: ./components/CourseDetails/QuestionsAnswerDialog/index.tsx
















var QuestionAnswserDialog = function() {
    var ref, ref1, ref2, ref3;
    var isMobile = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var ref4 = (0,react.useState)(0), currentQuestionIndex = ref4[0], setCurrentQuestionIndex = ref4[1];
    var ref5 = (0,react.useState)({}), userAnswers = ref5[0], setUserAnswers = ref5[1];
    var ref6 = (0,react.useContext)(CourseDetailsContext), openQuestionAnswerDialog = ref6.openQuestionAnswerDialog, setOpenQuestionAnswerDialog = ref6.setOpenQuestionAnswerDialog, courseInfo = ref6.courseInfo, currentLecture = ref6.currentLecture, setCurrentLecture = ref6.setCurrentLecture, refetchCourse = ref6.refetchCourse, setOpenCoursePaywall = ref6.setOpenCoursePaywall;
    var ref7 = (0,react.useState)(false), isShowingResult = ref7[0], setIsShowingResult = ref7[1];
    var currentLectureIndex = (0,react.useMemo)(function() {
        if (!currentLecture) return -1;
        return (courseInfo.lectures || []).findIndex(function(lec) {
            return lec.id === (currentLecture === null || currentLecture === void 0 ? void 0 : currentLecture.id);
        });
    }, [
        courseInfo,
        currentLecture
    ]);
    (0,react.useEffect)(function() {
        if (openQuestionAnswerDialog) {
            var ref;
            setCurrentQuestionIndex(0);
            setUserAnswers({});
            if (currentLecture === null || currentLecture === void 0 ? void 0 : (ref = currentLecture.questions) === null || ref === void 0 ? void 0 : ref.some(function(ques) {
                return !!ques.user_answer_id;
            })) {
                setIsShowingResult(true);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        openQuestionAnswerDialog
    ]);
    var handleAnswerAQuestion = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callback) {
            var ref, ref1, ref2, ref3;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        _ctx.next = 4;
                        return (0,course/* answerAQuestion */.$i)({
                            courseId: courseInfo.id.toString(),
                            lectureId: currentLecture === null || currentLecture === void 0 ? void 0 : (ref = currentLecture.id) === null || ref === void 0 ? void 0 : ref.toString(),
                            questionId: (ref1 = currentLecture === null || currentLecture === void 0 ? void 0 : currentLecture.questions[currentQuestionIndex]) === null || ref1 === void 0 ? void 0 : ref1.id,
                            answerId: userAnswers[(ref2 = currentLecture === null || currentLecture === void 0 ? void 0 : currentLecture.questions[currentQuestionIndex]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.id) === null || ref3 === void 0 ? void 0 : ref3.toString()]
                        });
                    case 4:
                        callback();
                        _ctx.next = 9;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function handleAnswerAQuestion(callback) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClose = function() {
        refetchCourse();
        setOpenQuestionAnswerDialog(false);
    };
    if (!currentLecture) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: openQuestionAnswerDialog,
        maxWidth: "lg",
        scroll: "body",
        fullScreen: isMobile,
        PaperProps: {
            style: {
                backgroundColor: "transparent",
                boxShadow: "none"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (QuestionsAnswerDialog_module_default()).dialogWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (QuestionsAnswerDialog_module_default()).closeBtn,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "close",
                        width: 28,
                        height: 28,
                        onClick: function() {
                            return handleClose();
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (QuestionsAnswerDialog_module_default()).container,
                    children: isShowingResult ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionsAnswerDialog_AnswersResult, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (QuestionsAnswerDialog_module_default()).actions,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (QuestionsAnswerDialog_module_default()).backBtn,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            text: "もう一度挑戦する",
                                            onClick: function() {
                                                setCurrentQuestionIndex(0);
                                                setUserAnswers({});
                                                setIsShowingResult(false);
                                            }
                                        })
                                    }),
                                    currentLectureIndex < courseInfo.lectures.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (QuestionsAnswerDialog_module_default()).nextBtn,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            text: "次のレクチャーへ",
                                            onClick: function() {
                                                handleClose();
                                                if (currentLectureIndex >= courseInfo.lectures.length - 1) return;
                                                var newLectureIndex = currentLectureIndex + 1;
                                                var newLecture = courseInfo.lectures[newLectureIndex];
                                                if (newLecture.type === course/* LecturePaidType.Free */.ed.Free) {
                                                    setCurrentLecture(newLecture);
                                                    return;
                                                }
                                                // if can watch
                                                if (courseInfo.is_owner || courseInfo.is_purchased) {
                                                    setCurrentLecture(newLecture);
                                                } else {
                                                    // if can't watch => open paywall
                                                    setOpenCoursePaywall && setOpenCoursePaywall(true);
                                                    return;
                                                }
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (QuestionsAnswerDialog_module_default()).questionsCount,
                                children: [
                                    "クイズ ",
                                    currentQuestionIndex + 1,
                                    "/",
                                    currentLecture === null || currentLecture === void 0 ? void 0 : (ref = currentLecture.questions) === null || ref === void 0 ? void 0 : ref.length
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentQuestionView, {
                                question: currentLecture === null || currentLecture === void 0 ? void 0 : currentLecture.questions[currentQuestionIndex],
                                userAnswers: userAnswers,
                                setUserAnswers: setUserAnswers
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (QuestionsAnswerDialog_module_default()).actions,
                                children: [
                                    currentQuestionIndex > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (QuestionsAnswerDialog_module_default()).backBtn,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            text: "前のクイズを見る",
                                            onClick: function() {
                                                if (currentQuestionIndex > 0) {
                                                    setCurrentQuestionIndex(currentQuestionIndex - 1);
                                                }
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (QuestionsAnswerDialog_module_default()).nextBtn,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            text: currentQuestionIndex === (currentLecture === null || currentLecture === void 0 ? void 0 : (ref1 = currentLecture.questions) === null || ref1 === void 0 ? void 0 : ref1.length) - 1 ? "解答して結果を見る" : "解答して次へ",
                                            disabled: ((ref2 = currentLecture === null || currentLecture === void 0 ? void 0 : currentLecture.questions[currentQuestionIndex]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.id) === null || ref3 === void 0 ? void 0 : ref3.toString()) in userAnswers ? false : true,
                                            onClick: function() {
                                                var ref, ref1;
                                                if (currentQuestionIndex < (currentLecture === null || currentLecture === void 0 ? void 0 : (ref = currentLecture.questions) === null || ref === void 0 ? void 0 : ref.length) - 1) {
                                                    void handleAnswerAQuestion(function() {
                                                        setCurrentQuestionIndex(currentQuestionIndex + 1);
                                                    });
                                                } else if (currentQuestionIndex === (currentLecture === null || currentLecture === void 0 ? void 0 : (ref1 = currentLecture.questions) === null || ref1 === void 0 ? void 0 : ref1.length) - 1) {
                                                    void handleAnswerAQuestion(function() {
                                                        refetchCourse();
                                                        setIsShowingResult(true);
                                                    });
                                                }
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var CurrentQuestionView = function(param) {
    var question = param.question, userAnswers = param.userAnswers, setUserAnswers = param.setUserAnswers;
    if (!question) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var onChooseAnswer = function(answersId) {
        setUserAnswers((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, userAnswers), (0,_define_property/* default */.Z)({}, question.id.toString(), answersId)));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (QuestionsAnswerDialog_module_default()).currentQuestionWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (QuestionsAnswerDialog_module_default()).questionDetail,
                children: question.detail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (QuestionsAnswerDialog_module_default()).answersList,
                children: question.answers.map(function(answer, index) {
                    var isSelected = userAnswers[question.id.toString()] === answer.id;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerItemView/* default */.Z, {
                        onChooseAnswer: onChooseAnswer,
                        type: isSelected ? "selected" : "normal",
                        answerItem: answer,
                        answerIndex: index
                    }, "answer-".concat(index));
                })
            })
        ]
    });
};
/* harmony default export */ var QuestionsAnswerDialog = (QuestionAnswserDialog);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./store/global.ts
var global = __webpack_require__(8405);
// EXTERNAL MODULE: ./components/CourseDetails/LecturesMenu/LecturesMenu.module.scss
var LecturesMenu_module = __webpack_require__(98237);
var LecturesMenu_module_default = /*#__PURE__*/__webpack_require__.n(LecturesMenu_module);
;// CONCATENATED MODULE: ./components/CourseDetails/LecturesMenu/index.tsx











var LecturesMenu = function() {
    var ref, ref1;
    var ref2 = (0,react.useContext)(CourseDetailsContext), courseInfo = ref2.courseInfo, currentLecture = ref2.currentLecture, viewdLectureIds = ref2.viewdLectureIds, setCurrentLecture = ref2.setCurrentLecture, setOpenCoursePaywall = ref2.setOpenCoursePaywall;
    // const setSnackbarMessage = useGlobalStore(
    //   (state) => state.setSnackbarMessage
    // );
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var totalDuration = (0,react.useMemo)(function() {
        return (courseInfo.lectures || []).reduce(function(result, item) {
            var ref;
            return result + ((ref = item.lecture_media) === null || ref === void 0 ? void 0 : ref.duration) || 0;
        }, 0);
    }, [
        courseInfo.lectures
    ]);
    var handleChooseLecture = function(lecture) {
        var ref;
        if (!currentAuth) {
            showLogin({});
            return;
        }
        var newLectureIndex = (ref = courseInfo.lectures) === null || ref === void 0 ? void 0 : ref.findIndex(function(lec) {
            return lec.id === lecture.id;
        });
        if (newLectureIndex < 0) return;
        // only first lecture is free
        if (lecture.type === course/* LecturePaidType.Free */.ed.Free) {
            setCurrentLecture(lecture);
            return;
        }
        // if can watch
        if (courseInfo.is_owner || courseInfo.is_purchased) {
            setCurrentLecture(lecture);
        } else {
            // if can't watch => open paywall
            setOpenCoursePaywall(true);
            return;
        }
    };
    var totalViewCount = (0,react.useMemo)(function() {
        return (courseInfo.lectures || []).reduce(function(result, item) {
            return result + item.view_count;
        }, 0);
    }, [
        courseInfo.lectures
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (LecturesMenu_module_default()).lecturesMenuWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (LecturesMenu_module_default()).lecturesMenu,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (LecturesMenu_module_default()).menuTop,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (LecturesMenu_module_default()).courseTitle,
                            children: courseInfo.title
                        }),
                        !courseInfo.is_purchased && !courseInfo.is_owner && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (LecturesMenu_module_default()).purchaseInfo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LecturesMenu_module_default()).openPaywallButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    text: "コースを受講する",
                                    fullWidth: true,
                                    onClick: function() {
                                        if (!currentAuth) {
                                            showLogin({});
                                            return;
                                        }
                                        setOpenCoursePaywall(true);
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (LecturesMenu_module_default()).courseTotalInfo,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (LecturesMenu_module_default()).lecturesCount,
                                    children: [
                                        "レクチャー (",
                                        (ref = courseInfo.lectures) === null || ref === void 0 ? void 0 : ref.length,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (LecturesMenu_module_default()).minutes,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (LecturesMenu_module_default()).durationWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (LecturesMenu_module_default()).icon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                        name: "video",
                                                        width: 16,
                                                        height: 16
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (LecturesMenu_module_default()).number,
                                                    children: (0,utils/* secondsToHms */.qt)(totalDuration)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (LecturesMenu_module_default()).viewCount,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (LecturesMenu_module_default()).icon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                        name: "view-black",
                                                        width: 18,
                                                        height: 18
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (LecturesMenu_module_default()).number,
                                                    children: (0,utils/* numberToString */.D$)(totalViewCount, 1)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LecturesMenu_module_default()).lecturesList,
                    children: (ref1 = courseInfo.lectures) === null || ref1 === void 0 ? void 0 : ref1.map(function(lecture, index) {
                        var idsViewed = lecture.is_viewed || viewdLectureIds.includes(lecture.id);
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((LecturesMenu_module_default()).lectureItem, (0,_define_property/* default */.Z)({}, (LecturesMenu_module_default()).currentItem, lecture.id === (currentLecture === null || currentLecture === void 0 ? void 0 : currentLecture.id))),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (LecturesMenu_module_default()).lectureStatus,
                                    children: lecture.id === (currentLecture === null || currentLecture === void 0 ? void 0 : currentLecture.id) ? idsViewed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                        name: "done",
                                        width: 16,
                                        height: 16
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LecturesMenu_module_default()).doing
                                    }) : idsViewed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                        name: "done",
                                        width: 16,
                                        height: 16
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LecturesMenu_module_default()).notYet
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (LecturesMenu_module_default()).lectureInfo,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (LecturesMenu_module_default()).lectureTitleWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (LecturesMenu_module_default()).lectureIndex,
                                                    children: [
                                                        index + 1,
                                                        "."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (LecturesMenu_module_default()).lectureTitle,
                                                    onClick: function() {
                                                        return handleChooseLecture(lecture);
                                                    },
                                                    children: lecture.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (LecturesMenu_module_default()).lectureDuration,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (LecturesMenu_module_default()).durationWrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (LecturesMenu_module_default()).icon,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                                name: "video",
                                                                width: 16,
                                                                height: 16
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (LecturesMenu_module_default()).number,
                                                            children: (0,utils/* secondsToHms */.qt)(lecture.lecture_media.duration)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (LecturesMenu_module_default()).viewCount,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (LecturesMenu_module_default()).icon,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                                name: "view-black",
                                                                width: 18,
                                                                height: 18
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (LecturesMenu_module_default()).number,
                                                            children: (0,utils/* numberToString */.D$)(lecture.view_count, 1)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                lecture.type === course/* LecturePaidType.Free */.ed.Free && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (LecturesMenu_module_default()).lectureType,
                                    children: "無料"
                                })
                            ]
                        }, lecture.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var CourseDetails_LecturesMenu = (LecturesMenu);

// EXTERNAL MODULE: ./store/timeline.ts
var timeline = __webpack_require__(12800);
// EXTERNAL MODULE: ./components/CourseDetails/CoursePaymentDialog/CoursePaymentDialog.module.scss
var CoursePaymentDialog_module = __webpack_require__(60391);
var CoursePaymentDialog_module_default = /*#__PURE__*/__webpack_require__.n(CoursePaymentDialog_module);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(86664);
// EXTERNAL MODULE: ./components/CourseDetails/CoursePaymentDialog/InputCard/InputCard.module.scss
var InputCard_module = __webpack_require__(12147);
var InputCard_module_default = /*#__PURE__*/__webpack_require__.n(InputCard_module);
;// CONCATENATED MODULE: ./components/CourseDetails/CoursePaymentDialog/InputCard/index.tsx




var InputCard = function(param) {
    var handleCardNumberChange = param.handleCardNumberChange, setName = param.setName, name = param.name, handleCardExpiryChange = param.handleCardExpiryChange, handleCardCvcChange = param.handleCardCvcChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (InputCard_module_default()).inputCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (InputCard_module_default()).inputGroup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: (InputCard_module_default()).label,
                        children: "カード番号"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (InputCard_module_default()).cardInput,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardNumberElement, {
                            onChange: handleCardNumberChange,
                            options: {
                                showIcon: true,
                                style: {
                                    base: {
                                        fontSize: "14px",
                                        color: "#000000",
                                        "::placeholder": {
                                            color: "#CCCCCC"
                                        }
                                    },
                                    invalid: {
                                        color: "#FA553F"
                                    }
                                }
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (InputCard_module_default()).inputGroup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: (InputCard_module_default()).label,
                        htmlFor: "cc-name",
                        children: "お名前"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        id: "cc-name",
                        name: "cc-name",
                        placeholder: "TARO SUZUKI",
                        value: name,
                        onChange: function(e) {
                            return setName(e.target.value);
                        },
                        autoComplete: "cc-name"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (InputCard_module_default()).inputGroupWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((InputCard_module_default()).inputGroup, (InputCard_module_default()).expiry),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: (InputCard_module_default()).label,
                                children: "有効期限"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (InputCard_module_default()).cardInput,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardExpiryElement, {
                                    onChange: handleCardExpiryChange,
                                    options: {
                                        style: {
                                            base: {
                                                fontSize: "14px",
                                                color: "#000000",
                                                "::placeholder": {
                                                    color: "#CCCCCC"
                                                }
                                            },
                                            invalid: {
                                                color: "#FA553F"
                                            }
                                        }
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((InputCard_module_default()).inputGroup, (InputCard_module_default()).cvc),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: (InputCard_module_default()).label,
                                children: "コード"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (InputCard_module_default()).cardInput,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardCvcElement, {
                                    onChange: handleCardCvcChange,
                                    options: {
                                        style: {
                                            base: {
                                                fontSize: "14px",
                                                color: "#000000",
                                                "::placeholder": {
                                                    color: "#CCCCCC"
                                                }
                                            },
                                            invalid: {
                                                color: "#FA553F"
                                            }
                                        }
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CoursePaymentDialog_InputCard = (InputCard);

// EXTERNAL MODULE: ./components/common/UserInfo/index.tsx
var UserInfo = __webpack_require__(92371);
// EXTERNAL MODULE: ./components/CourseDetails/CoursePaymentDialog/CoursePreview/CoursePreview.module.scss
var CoursePreview_module = __webpack_require__(25024);
var CoursePreview_module_default = /*#__PURE__*/__webpack_require__.n(CoursePreview_module);
// EXTERNAL MODULE: ./components/common/CourseRatingView/index.tsx
var CourseRatingView = __webpack_require__(89261);
// EXTERNAL MODULE: ./components/common/RichContent/index.tsx + 1 modules
var RichContent = __webpack_require__(8348);
;// CONCATENATED MODULE: ./components/CourseDetails/CoursePaymentDialog/CoursePreview/index.tsx





// import Icon from 'components/common/Icon';




var CoursePreview = function() {
    var ref, ref1, ref2, ref3;
    var courseInfo = (0,react.useContext)(CourseDetailsContext).courseInfo;
    if (!courseInfo) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CoursePreview_module_default()).previewContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CoursePreview_module_default()).thumbImage,
                children: ((ref = courseInfo.thumbnail_image_media) === null || ref === void 0 ? void 0 : ref.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: ((ref1 = courseInfo.thumbnail_image_media) === null || ref1 === void 0 ? void 0 : ref1.url) || ""
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (CoursePreview_module_default()).noThumbText,
                    children: "サムネイル"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((CoursePreview_module_default()).courseTitle, (0,_define_property/* default */.Z)({}, (CoursePreview_module_default()).blank, !courseInfo.title)),
                children: courseInfo.title ? courseInfo.title : "タイトル"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CoursePreview_module_default()).creatorInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            pointerEvents: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfo/* default */.Z, {
                            user: courseInfo.user,
                            avatarSize: 36,
                            badgeSize: 32
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseRatingView/* default */.Z, {
                        count: (ref2 = courseInfo.review_summary) === null || ref2 === void 0 ? void 0 : ref2.count,
                        rating: (ref3 = courseInfo.review_summary) === null || ref3 === void 0 ? void 0 : ref3.rating,
                        className: (CoursePreview_module_default()).ratingSection
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CoursePreview_module_default()).courseDescription,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichContent/* default */.Z, {
                    text: courseInfo.description || ""
                })
            })
        ]
    });
};
/* harmony default export */ var CoursePaymentDialog_CoursePreview = (CoursePreview);

// EXTERNAL MODULE: ./components/CourseDetails/CoursePaymentDialog/PolicyDescription/PolicyDescription.module.scss
var PolicyDescription_module = __webpack_require__(44701);
var PolicyDescription_module_default = /*#__PURE__*/__webpack_require__.n(PolicyDescription_module);
;// CONCATENATED MODULE: ./components/CourseDetails/CoursePaymentDialog/PolicyDescription/index.tsx



var PolicyDescription = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PolicyDescription_module_default()).smallPrint,
        children: [
            "購入すると、",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (PolicyDescription_module_default()).link,
                href: utils/* USER_TERM_URL */.Du,
                target: "_blank",
                rel: "noopener",
                children: "利用規約"
            }),
            "、",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (PolicyDescription_module_default()).link,
                href: utils/* POLICY_URL */.Jk,
                target: "_blank",
                rel: "noopener",
                children: "プライバシーポリシー"
            }),
            "に",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "同意したことになります。"
        ]
    });
};
/* harmony default export */ var CoursePaymentDialog_PolicyDescription = (PolicyDescription);

// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 164 modules
var lib_esm = __webpack_require__(38367);
// EXTERNAL MODULE: ./service/payment.ts
var payment = __webpack_require__(43827);
// EXTERNAL MODULE: ./components/common/TeenagePaymentAlertPopup/index.tsx
var TeenagePaymentAlertPopup = __webpack_require__(55674);
// EXTERNAL MODULE: ./common/utils/payment.ts
var utils_payment = __webpack_require__(60612);
;// CONCATENATED MODULE: ./components/CourseDetails/CoursePaymentDialog/index.tsx






















function CoursePaymentDialog() {
    var ref;
    var isMobile = (0,utils/* useMediaQuery */.ac)("(max-width: 875px)");
    var ref1 = (0,react.useContext)(CourseDetailsContext), courseInfo = ref1.courseInfo, openCoursePaywall = ref1.openCoursePaywall, setOpenCoursePaywall = ref1.setOpenCoursePaywall, refetchCourse = ref1.refetchCourse;
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var ref2 = (0,react.useState)(), stripe3DSUrl = ref2[0], setStripe3DSUrl = ref2[1];
    var ref3 = (0,react.useState)(null), teenAgePaymentErrorReason = ref3[0], setTeenAgePaymentErrorReason = ref3[1];
    var ref4 = (0,react.useState)(false), isProcessing = ref4[0], setIsProcessing = ref4[1];
    var ref5 = (0,react.useState)(""), name = ref5[0], setName = ref5[1];
    var ref6 = (0,react.useState)(null), cardError = ref6[0], setCardError = ref6[1];
    var ref7 = (0,react.useState)(null), expiryError = ref7[0], setExpiryError = ref7[1];
    var ref8 = (0,react.useState)(null), cvcError = ref8[0], setCvcError = ref8[1];
    var ref9 = (0,react.useState)(false), cardComplete = ref9[0], setCardComplete = ref9[1];
    var ref10 = (0,react.useState)(false), expiryComplete = ref10[0], setExpiryComplete = ref10[1];
    var ref11 = (0,react.useState)(false), cvcComplete = ref11[0], setCvcComplete = ref11[1];
    var ref12 = (0,es.useQuery)([
        "getSubscriptionInfo"
    ], (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!isAuthInit || !currentUser)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.reject());
                case 2:
                    _ctx.next = 4;
                    return axios/* default.get */.Z.get("/users/accounts/subscription_info");
                case 4:
                    return _ctx.abrupt("return", _ctx.sent.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        enabled: isAuthInit && !!currentUser
    }), isLoading = ref12.isLoading, data = ref12.data;
    var paymentMethod = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.payment_method;
    var stripe = (0,react_stripe_umd.useStripe)();
    var elements = (0,react_stripe_umd.useElements)();
    var isValidInput = paymentMethod || name && !cardError && !expiryError && !cvcError && cardComplete && expiryComplete && cvcComplete;
    // initCreditCard
    var initCreditCard = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var getIntentResponse, cardNumberElement, payment_method, setupIntent;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,payment/* getInitCreditIntent */.fS)();
                    case 3:
                        getIntentResponse = _ctx.sent;
                        cardNumberElement = elements.getElement(react_stripe_umd.CardNumberElement);
                        payment_method = paymentMethod ? paymentMethod.id : {
                            card: cardNumberElement,
                            billing_details: {
                                name: name
                            }
                        };
                        _ctx.next = 8;
                        return stripe.confirmCardSetup(getIntentResponse.data.client_secret, {
                            payment_method: payment_method
                        });
                    case 8:
                        setupIntent = _ctx.sent.setupIntent;
                        if (!(!setupIntent || setupIntent.status !== "succeeded")) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error("Failed to create payment method");
                    case 11:
                        (0,lib_esm/* track */.j)("Add Credit Card Success", {
                            screen: "course_payment_dialog"
                        });
                        _ctx.next = 14;
                        return (0,payment/* setPaymentMethod */.$P)(setupIntent.payment_method);
                    case 14:
                        _ctx.next = 22;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,lib_esm/* track */.j)("Create Payment Method Failed", {
                            screen: "course_payment_dialog"
                        });
                        setIsProcessing(false);
                        setSnackbarMessage({
                            type: "error",
                            text: "カードが登録できませんでした"
                        });
                        throw new Error("Failed to create payment method");
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    16
                ]
            ]);
        }));
        return function initCreditCard() {
            return _ref.apply(this, arguments);
        };
    }();
    var onCompleteBuyCourse = function() {
        var ref;
        (0,lib_esm/* track */.j)("Buy Course", {
            course_id: (ref = courseInfo.id) === null || ref === void 0 ? void 0 : ref.toString(),
            course_name: courseInfo.title
        });
        setSnackbarMessage({
            type: "success",
            text: "コースを購入しました"
        });
        // need time for sync state of stripe and backend
        setTimeout(function() {
            refetchCourse();
            handleClose();
        }, 3000);
    };
    // callback when failed subscription
    var onFailedBuyCourse = function() {
        setIsProcessing(false);
        setSnackbarMessage({
            type: "error",
            text: "コースの購入に失敗しました"
        });
    };
    var handleBuyCourse = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var ref, ref1, checkTeenagePaymentResponse, isAbleToPay, ref2, ref3, buyCourseResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!isProcessing) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setIsProcessing(true);
                        if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.is_adult) {
                            _ctx.next = 20;
                            break;
                        }
                        _ctx.prev = 5;
                        ;
                        _ctx.next = 9;
                        return (0,payment/* checkPaymentHistoryTeenage */.Ui)({
                            price_amount: courseInfo.web_amount
                        });
                    case 9:
                        checkTeenagePaymentResponse = _ctx.sent;
                        isAbleToPay = checkTeenagePaymentResponse === null || checkTeenagePaymentResponse === void 0 ? void 0 : (ref = checkTeenagePaymentResponse.data) === null || ref === void 0 ? void 0 : ref.is_purchasable;
                        if (!(!isAbleToPay && (checkTeenagePaymentResponse === null || checkTeenagePaymentResponse === void 0 ? void 0 : (ref1 = checkTeenagePaymentResponse.data) === null || ref1 === void 0 ? void 0 : ref1.reason))) {
                            _ctx.next = 16;
                            break;
                        }
                        ;
                        (0,lib_esm/* track */.j)("Show Underage Payment Error", {
                            type: "course"
                        });
                        setTeenAgePaymentErrorReason(checkTeenagePaymentResponse === null || checkTeenagePaymentResponse === void 0 ? void 0 : (ref2 = checkTeenagePaymentResponse.data) === null || ref2 === void 0 ? void 0 : ref2.reason);
                        return _ctx.abrupt("return");
                    case 16:
                        _ctx.next = 20;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](5);
                    case 20:
                        _ctx.prev = 20;
                        if (paymentMethod) {
                            _ctx.next = 24;
                            break;
                        }
                        _ctx.next = 24;
                        return initCreditCard();
                    case 24:
                        _ctx.prev = 24;
                        ;
                        _ctx.next = 28;
                        return (0,course/* buyCourse */.nA)(courseInfo.id);
                    case 28:
                        buyCourseResponse = _ctx.sent;
                        if (buyCourseResponse === null || buyCourseResponse === void 0 ? void 0 : (ref3 = buyCourseResponse.confirm_response) === null || ref3 === void 0 ? void 0 : ref3.confirm_url) {
                            setStripe3DSUrl(buyCourseResponse.confirm_response.confirm_url);
                        } else {
                            onCompleteBuyCourse();
                        }
                        _ctx.next = 36;
                        break;
                    case 32:
                        _ctx.prev = 32;
                        _ctx.t1 = _ctx["catch"](24);
                        onFailedBuyCourse();
                        throw new Error("Failed to create buy course request");
                    case 36:
                        _ctx.next = 41;
                        break;
                    case 38:
                        _ctx.prev = 38;
                        _ctx.t2 = _ctx["catch"](20);
                        setIsProcessing(false);
                    case 41:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    18
                ],
                [
                    20,
                    38
                ],
                [
                    24,
                    32
                ]
            ]);
        }));
        return function handleBuyCourse(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!stripe3DSUrl) return;
        var handle3DSMessage = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
                var urlParams, clientSecret;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(event.data === utils_payment/* CHECK_3DS_CODE */.Fq)) {
                                _ctx.next = 13;
                                break;
                            }
                            _ctx.prev = 1;
                            urlParams = new URLSearchParams(stripe3DSUrl);
                            clientSecret = urlParams.get("payment_intent_client_secret");
                            _ctx.next = 6;
                            return stripe.retrievePaymentIntent(clientSecret).then(function(result) {
                                if (result.error) {
                                    (0,lib_esm/* track */.j)("Onetime Payment With 3DS", {
                                        type: "course",
                                        status: "failed"
                                    });
                                    onFailedBuyCourse();
                                } else {
                                    if (result.paymentIntent.status === "succeeded") {
                                        // Show your customer that the payment has succeeded
                                        onCompleteBuyCourse();
                                        (0,lib_esm/* track */.j)("Onetime Payment With 3DS", {
                                            type: "course",
                                            status: "succeeded"
                                        });
                                    } else if (result.paymentIntent.status === "requires_payment_method") {
                                        onFailedBuyCourse();
                                        (0,lib_esm/* track */.j)("Onetime Payment With 3DS", {
                                            type: "course",
                                            status: "failed"
                                        });
                                    }
                                }
                                setStripe3DSUrl(null);
                            });
                        case 6:
                            _ctx.next = 13;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](1);
                            console.log("Error", _ctx.t0);
                            onFailedBuyCourse();
                            setStripe3DSUrl(null);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        8
                    ]
                ]);
            }));
            return function handle3DSMessage(event) {
                return _ref.apply(this, arguments);
            };
        }();
        window.addEventListener("message", handle3DSMessage);
        return function() {
            return window.removeEventListener("message", handle3DSMessage);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stripe3DSUrl
    ]);
    // Check input
    var handleCardNumberChange = function(e) {
        setCardError(e.error ? e.error.message : null);
        setCardComplete(e.complete);
    };
    var handleCardExpiryChange = function(e) {
        setExpiryError(e.error ? e.error.message : null);
        setExpiryComplete(e.complete);
    };
    var handleCardCvcChange = function(e) {
        setCvcError(e.error ? e.error.message : null);
        setCvcComplete(e.complete);
    };
    var paymentInfo = function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CoursePaymentDialog_module_default()).formSection,
            children: [
                isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CoursePaymentDialog_module_default()).loading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "loading-anim-3",
                        width: 24,
                        height: 24
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (CoursePaymentDialog_module_default()).title,
                            children: [
                                (ref = courseInfo.user) === null || ref === void 0 ? void 0 : ref.name,
                                "さんの",
                                "\n",
                                "コースを購入する"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (CoursePaymentDialog_module_default()).discount,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (CoursePaymentDialog_module_default()).name,
                                    children: courseInfo.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (CoursePaymentDialog_module_default()).line
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CoursePaymentDialog_module_default()).price,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (CoursePaymentDialog_module_default()).number,
                                        children: [
                                            (ref1 = courseInfo.web_amount) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString(),
                                            "円"
                                        ]
                                    })
                                })
                            ]
                        }),
                        !paymentMethod ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CoursePaymentDialog_InputCard, {
                            setName: setName,
                            name: name,
                            handleCardCvcChange: handleCardCvcChange,
                            handleCardExpiryChange: handleCardExpiryChange,
                            handleCardNumberChange: handleCardNumberChange
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (CoursePaymentDialog_module_default()).existingCard,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (CoursePaymentDialog_module_default()).ccNumber,
                                    children: [
                                        "**** **** **** ",
                                        paymentMethod.last4
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CoursePaymentDialog_module_default()).brandIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                        name: "cc/".concat(paymentMethod.brand),
                                        width: 38,
                                        height: 26
                                    })
                                })
                            ]
                        })
                    ]
                }),
                isProcessing ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CoursePaymentDialog_module_default()).confirmBtn,
                    style: {
                        cursor: isProcessing ? "not-allowed" : "pointer"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "loading-anim-2",
                        width: 24,
                        height: 24
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "submit",
                        className: (CoursePaymentDialog_module_default()).confirmBtn,
                        onClick: function(e) {
                            handleBuyCourse(e);
                        },
                        disabled: !isValidInput || isProcessing,
                        children: "コースを購入する"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoursePaymentDialog_PolicyDescription, {})
            ]
        });
    };
    var handleClose = function() {
        setOpenCoursePaywall(false);
    };
    if (!openCoursePaywall) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (courseInfo.is_owner) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (courseInfo.is_purchased) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        open: openCoursePaywall,
        onClose: function() {
            if (!isProcessing) {
                handleClose();
            }
        },
        maxWidth: "lg",
        scroll: "body",
        disableEnforceFocus: true,
        disableAutoFocus: true,
        disableRestoreFocus: true,
        fullScreen: isMobile,
        PaperProps: {
            style: {
                backgroundColor: "transparent",
                boxShadow: "none"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CoursePaymentDialog_module_default()).dialogWrapper,
                children: [
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CoursePaymentDialog_module_default()).closeBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "close",
                            width: 28,
                            height: 28,
                            onClick: !isProcessing ? handleClose : undefined
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CoursePaymentDialog_module_default()).container,
                        children: [
                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CoursePaymentDialog_module_default()).closeBtn,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    name: "close",
                                    width: 28,
                                    height: 28,
                                    onClick: !isProcessing ? handleClose : undefined
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoursePaymentDialog_CoursePreview, {}),
                            paymentInfo()
                        ]
                    })
                ]
            }),
            teenAgePaymentErrorReason && /*#__PURE__*/ (0,jsx_runtime.jsx)(TeenagePaymentAlertPopup/* default */.Z, {
                reason: teenAgePaymentErrorReason,
                setReason: setTeenAgePaymentErrorReason
            }),
            !!stripe3DSUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                open: !!stripe3DSUrl,
                maxWidth: "lg",
                scroll: "body",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CoursePaymentDialog_module_default()).stripe3DSCheckDialog,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        src: stripe3DSUrl,
                        width: 600,
                        height: 400
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/CourseDetails/ReviewsSection/index.tsx + 2 modules
var ReviewsSection = __webpack_require__(2873);
// EXTERNAL MODULE: ./common/utils/course.ts
var utils_course = __webpack_require__(5439);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/CourseDetails/index.tsx
















var CourseDetailsContext = /*#__PURE__*/ (0,react.createContext)(null);
var CourseDetails = function(param) {
    var courseInfo = param.courseInfo, refetchCourse = param.refetchCourse, currentLecture = param.currentLecture, setCurrentLecture = param.setCurrentLecture;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var showMembershipPayDialogInput = (0,global/* default */.Z)(function(state) {
        return state.showMembershipPayDialogInput;
    });
    var showPaymentDialogInput = (0,global/* default */.Z)(function(state) {
        return state.showPaymentDialogInput;
    });
    var showTippingDialogInput = (0,global/* default */.Z)(function(state) {
        return state.showTippingDialogInput;
    });
    var isSmallScreen = (0,utils/* useMediaQuery */.ac)("(max-width: 1000px)");
    var ref6 = (0,react.useState)(false), openCoursePaywall = ref6[0], setOpenCoursePaywall = ref6[1];
    var ref7 = (0,react.useState)([]), viewdLectureIds = ref7[0], setViewedLectureIds = ref7[1];
    var ref8 = (0,react.useState)(false), openQuestionAnswerDialog = ref8[0], setOpenQuestionAnswerDialog = ref8[1];
    (0,react.useEffect)(function() {
        if (courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.id) {
            setViewedLectureIds([]);
        }
    }, [
        courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.id
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!openCoursePaywall) return;
        var showingStripeInDialog = !!(showPaymentDialogInput === null || showPaymentDialogInput === void 0 ? void 0 : (ref = showPaymentDialogInput.creator) === null || ref === void 0 ? void 0 : ref.is_creator) && (showPaymentDialogInput === null || showPaymentDialogInput === void 0 ? void 0 : (ref1 = showPaymentDialogInput.creator) === null || ref1 === void 0 ? void 0 : ref1.is_open_for_subscription) || !!showTippingDialogInput || !!(showMembershipPayDialogInput === null || showMembershipPayDialogInput === void 0 ? void 0 : showMembershipPayDialogInput.open);
        if (showingStripeInDialog) {
            setOpenCoursePaywall(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showPaymentDialogInput,
        showTippingDialogInput,
        showMembershipPayDialogInput, 
    ]);
    if (!courseInfo) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseDetailsContext.Provider, {
        value: {
            openQuestionAnswerDialog: openQuestionAnswerDialog,
            setOpenQuestionAnswerDialog: setOpenQuestionAnswerDialog,
            courseInfo: courseInfo,
            currentLecture: currentLecture,
            setCurrentLecture: setCurrentLecture,
            openCoursePaywall: openCoursePaywall,
            setOpenCoursePaywall: setOpenCoursePaywall,
            refetchCourse: refetchCourse,
            viewdLectureIds: viewdLectureIds,
            setViewedLectureIds: setViewedLectureIds
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CourseDetails_module_default()).courseDetailWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CourseDetails_module_default()).courseContentWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CourseDetails_module_default()).lectureVideoWrapper,
                            children: currentLecture ? (0,utils_course/* canWatchLectureVideo */._8)(courseInfo, currentLecture) && currentAuth ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewLectureVideoPlayer/* default */.Z, {
                                lecture: currentLecture
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CourseDetails_module_default()).lectureThumbnail,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: (ref = currentLecture.lecture_thumbnail_media) === null || ref === void 0 ? void 0 : ref.url,
                                        width: (ref1 = currentLecture.lecture_thumbnail_media) === null || ref1 === void 0 ? void 0 : ref1.width,
                                        height: (ref2 = currentLecture.lecture_thumbnail_media) === null || ref2 === void 0 ? void 0 : ref2.height,
                                        alt: currentLecture.title || ""
                                    }),
                                    (!currentAuth || currentLecture.type === course/* LecturePaidType.Paid */.ed.Paid && !courseInfo.is_purchased) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CourseDetails_module_default()).registerBtnWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            text: !currentAuth ? "無料でログインする" : "コースを受講する",
                                            onClick: function() {
                                                if (!currentAuth) {
                                                    showLogin({});
                                                    return;
                                                }
                                                setOpenCoursePaywall(true);
                                            }
                                        })
                                    })
                                ]
                            }) : courseInfo.thumbnail_image_media && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CourseDetails_module_default()).lectureThumbnail,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: (ref3 = courseInfo.thumbnail_image_media) === null || ref3 === void 0 ? void 0 : ref3.url,
                                    width: (ref4 = courseInfo.thumbnail_image_media) === null || ref4 === void 0 ? void 0 : ref4.width,
                                    height: (ref5 = courseInfo.thumbnail_image_media) === null || ref5 === void 0 ? void 0 : ref5.height,
                                    alt: courseInfo.title || ""
                                })
                            })
                        }),
                        isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseDetails_LecturesMenu, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CourseDetails_module_default()).courseContent,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Tabs, {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                selectedTabClassName: (CourseDetails_module_default()).selected,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.TabList, {
                                        className: (CourseDetails_module_default()).courseContentTabs,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Tab, {
                                                className: (CourseDetails_module_default()).tab,
                                                id: "overview",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (CourseDetails_module_default()).tabContent,
                                                    children: "概要"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Tab, {
                                                className: (CourseDetails_module_default()).tab,
                                                id: "reviews",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (CourseDetails_module_default()).tabContent,
                                                    children: "レビュー"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.TabPanel, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (CourseDetails_module_default()).tabContentWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseOverview/* default */.Z, {
                                                courseInfo: courseInfo
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.TabPanel, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (CourseDetails_module_default()).tabContentWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection/* default */.Z, {})
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                !isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseDetails_LecturesMenu, {}),
                openQuestionAnswerDialog && currentLecture && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionsAnswerDialog, {}),
                currentAuth && openCoursePaywall && /*#__PURE__*/ (0,jsx_runtime.jsx)(CoursePaymentDialog, {})
            ]
        })
    });
};
/* harmony default export */ var components_CourseDetails = (CourseDetails);


/***/ }),

/***/ 89261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_lab__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46720);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var common_utils_course__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5439);
/* harmony import */ var _CourseRatingView_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76891);
/* harmony import */ var _CourseRatingView_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_CourseRatingView_module_scss__WEBPACK_IMPORTED_MODULE_3__);






var CourseRatingView = function(param) {
    var count = param.count, rating = param.rating, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_CourseRatingView_module_scss__WEBPACK_IMPORTED_MODULE_3___default().ratingSection), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, className, !!className)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_CourseRatingView_module_scss__WEBPACK_IMPORTED_MODULE_3___default().rateValue),
                children: (0,common_utils_course__WEBPACK_IMPORTED_MODULE_2__/* .ratingNumberWithDecimal */ .LN)(rating)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                name: "ratingView",
                value: rating,
                size: "large",
                readOnly: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: (_CourseRatingView_module_scss__WEBPACK_IMPORTED_MODULE_3___default().ratingCount),
                children: [
                    "(",
                    count || 0,
                    ")"
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseRatingView);


/***/ }),

/***/ 8325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProgressRing; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ProgressRing_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88821);
/* harmony import */ var _ProgressRing_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ProgressRing_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function ProgressRing(param) {
    var radius = param.radius, current = param.current, total = param.total;
    var stroke = 3;
    var normalizedRadius = radius - stroke * 2;
    var circumference = normalizedRadius * 2 * Math.PI;
    var progress = current > total ? 1 : current / total;
    var strokeDashoffset = circumference - progress * circumference;
    var strokeColor = current <= total ? "#0abc71" : "#e54040";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_ProgressRing_module_scss__WEBPACK_IMPORTED_MODULE_2___default().ring),
        style: {
            width: radius * 2,
            height: radius * 2
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ProgressRing_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_ProgressRing_module_scss__WEBPACK_IMPORTED_MODULE_2___default().overflow), current > total)),
                children: total - current
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                height: radius * 2,
                width: radius * 2,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        stroke: "#cccccc",
                        fill: "transparent",
                        strokeWidth: stroke,
                        r: normalizedRadius,
                        cx: radius,
                        cy: radius
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        stroke: strokeColor,
                        fill: "transparent",
                        strokeWidth: stroke,
                        strokeDasharray: "".concat(circumference, " ").concat(circumference),
                        style: {
                            strokeDashoffset: strokeDashoffset
                        },
                        r: normalizedRadius,
                        cx: radius,
                        cy: radius
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 8348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RichContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
;// CONCATENATED MODULE: ./common/utils/escapeHtml.ts
function escapeHtml(unsafe) {
    return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
};

// EXTERNAL MODULE: ./components/common/RichContent/RichContent.module.scss
var RichContent_module = __webpack_require__(54681);
var RichContent_module_default = /*#__PURE__*/__webpack_require__.n(RichContent_module);
;// CONCATENATED MODULE: ./components/common/RichContent/index.tsx






var specialRegex = /&lt;span style=&quot;background:#FFFF00; color:#000; padding:3px;&quot;&gt;(.+)&lt;\/span&gt;/g;
var hashtagRegex = (0,utils/* hashTagRegexFactoryWithSpace */._y)();
var linkRegex = (0,utils/* linkRegexFactory */.EU)();
var emailReplacer = function(match) {
    return '<span class="'.concat((RichContent_module_default()).email, '"><a target="_blank" rel="noopener noreferrer" href="mailto: ').concat(match, '">').concat(match, "</a></span>");
};
var linkReplacer = function(match) {
    if (utils/* VALID_EMAIL_REGEX.test */.Fh.test(match)) return emailReplacer(match);
    var href = "//".concat(match);
    if (match.startsWith("http") || match.startsWith("https")) {
        href = match;
    }
    return '<a href="'.concat((0,utils/* externalUrlRedirectLink */.tO)(href), '" class="').concat((RichContent_module_default()).link, '" target="_blank" rel="noopener noreferrer" onClick="(e) => e.stopPropagation()">').concat(match, "</a>");
};
var hashTagReplacer = function(match) {
    var startCharacter = match.substring(0, 1);
    var isStartOfLine = !startCharacter.match(/\s/);
    var showString = isStartOfLine ? match : match.substring(1);
    return "".concat(isStartOfLine ? "" : startCharacter, '<span class="').concat((RichContent_module_default()).hashtag, '"><a target="_blank" rel="noopener noreferrer" href="/topics/').concat(showString.substring(1), '">').concat(showString, "</a></span>");
};
function RichContent(param) {
    var text = param.text, _specialEscape = param.specialEscape, specialEscape = _specialEscape === void 0 ? false : _specialEscape, _mentionTargets = param.mentionTargets, mentionTargets = _mentionTargets === void 0 ? [] : _mentionTargets;
    var escapedText = (0,react.useMemo)(function() {
        var escaped = escapeHtml(text || "");
        if (specialEscape) {
            escaped = escaped.replace(specialRegex, '<span class="'.concat((RichContent_module_default()).special, '">$1</span>'));
        }
        escaped = escaped.replace(hashtagRegex, hashTagReplacer);
        // because of &#39; has #, should replace after check hash
        escaped = escaped.replace(/'/g, "&#39;");
        mentionTargets.forEach(function(mention) {
            escaped = escaped.replace("@".concat(mention.id), '<a target="_blank" onClick="(e) => e.stopPropagation()" href="/'.concat(mention.username, '" class="').concat((RichContent_module_default()).mention, '">@').concat(mention.name, "</a>"));
        });
        escaped = escaped.replace(linkRegex, linkReplacer);
        return escaped;
    }, [
        text,
        specialEscape,
        mentionTargets
    ]);
    // prevent onClick event when clicking on a link
    var handleClick = function(e) {
        var target = e.target;
        if (target.tagName.toLowerCase() === "a") {
            e.stopPropagation();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleClick,
        className: classnames_default()((RichContent_module_default()).richContentWrapper, "richcontent"),
        dangerouslySetInnerHTML: {
            __html: escapedText
        }
    });
};


/***/ }),

/***/ 55674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93579);
/* harmony import */ var _TeenagePaymentAlertPopup_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47098);
/* harmony import */ var _TeenagePaymentAlertPopup_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_TeenagePaymentAlertPopup_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_common_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98133);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22467);





var TeenagePaymentAlertPopup = function(param) {
    var reason = param.reason, setReason = param.setReason;
    var isMobile = (0,common_utils__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .ac)("(max-width: 767px)");
    if (!reason) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        open: !!reason,
        maxWidth: "lg",
        onClose: function() {
            return setReason(null);
        },
        scroll: "body",
        disableEnforceFocus: true,
        disableAutoFocus: true,
        disableRestoreFocus: true,
        PaperProps: {
            style: {
                backgroundColor: "transparent",
                boxShadow: "none"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_TeenagePaymentAlertPopup_module_scss__WEBPACK_IMPORTED_MODULE_4___default().dialogWrapper),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_TeenagePaymentAlertPopup_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                    children: reason === 1 ? "購入できません" : "上限金額に到達しました"
                }),
                reason === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_TeenagePaymentAlertPopup_module_scss__WEBPACK_IMPORTED_MODULE_4___default().subTitle),
                    children: [
                        "１回の購入金額の上限（1万円）",
                        isMobile ? "\n" : "",
                        "に達しているため、",
                        "\n",
                        "購入できません。"
                    ]
                }) : reason === 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_TeenagePaymentAlertPopup_module_scss__WEBPACK_IMPORTED_MODULE_4___default().subTitle),
                    children: [
                        "今月の購入金額の上限（月額3万円）",
                        isMobile ? "\n" : "",
                        "に達しているため、",
                        "\n",
                        "来月以降にお手続きください。"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_TeenagePaymentAlertPopup_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footer),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            text: "閉じる",
                            rounded: true,
                            onClick: function() {
                                return setReason(null);
                            }
                        }),
                        reason === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_TeenagePaymentAlertPopup_module_scss__WEBPACK_IMPORTED_MODULE_4___default().policy),
                            children: [
                                "購入金額の上限については、",
                                "\n",
                                "「",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    target: "_blank",
                                    href: common_utils__WEBPACK_IMPORTED_MODULE_2__/* .JUVELINE_POLICY_URL */ .Q7,
                                    children: "未成年ポリシー"
                                }),
                                "」をご確認ください。"
                            ]
                        }) : reason === 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_TeenagePaymentAlertPopup_module_scss__WEBPACK_IMPORTED_MODULE_4___default().policy),
                            children: [
                                "お心当たりがない場合は、",
                                "\n",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    target: "_blank",
                                    href: "https://help.postprime.com/hc/ja/requests/new?ticket_form_id=6512331197583",
                                    children: "サポートデスク"
                                }),
                                "までお問い合わせください。",
                                "\n",
                                "購入金額の上限については、",
                                "\n",
                                "「",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    target: "_blank",
                                    href: common_utils__WEBPACK_IMPORTED_MODULE_2__/* .JUVELINE_POLICY_URL */ .Q7,
                                    children: "未成年ポリシー"
                                }),
                                "」をご確認ください。"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TeenagePaymentAlertPopup);


/***/ }),

/***/ 55646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_TextEditor; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/draft-js/lib/Draft.js
var Draft = __webpack_require__(9041);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
// EXTERNAL MODULE: ./node_modules/draft-js/dist/Draft.css
var dist_Draft = __webpack_require__(40080);
// EXTERNAL MODULE: ./components/common/TextEditor/TextEditor.module.scss
var TextEditor_module = __webpack_require__(21086);
var TextEditor_module_default = /*#__PURE__*/__webpack_require__.n(TextEditor_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(76166);
;// CONCATENATED MODULE: ./common/utils/ErrorBoundaryClient/index.tsx




var ErrorBoundaryWithHandler = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundaryWithHandler, Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundaryWithHandler);
    function ErrorBoundaryWithHandler() {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundaryWithHandler);
        return _super.apply(this, arguments);
    }
    var _proto = ErrorBoundaryWithHandler.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.props.errorHandler();
        this.forceUpdate();
    };
    _proto.render = function render() {
        return this.props.children;
    };
    return ErrorBoundaryWithHandler;
}(react.Component);
/* harmony default export */ var ErrorBoundaryClient = (ErrorBoundaryWithHandler);

;// CONCATENATED MODULE: ./components/common/TextEditor/index.tsx
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ 








function findWithRegex(regex, contentBlock, callback) {
    var text = contentBlock.getText();
    var matchArr;
    var start;
    while((matchArr = regex.exec(text)) !== null){
        start = matchArr.index;
        callback(start, start + matchArr[0].length);
    }
}
var mentionSpan = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (TextEditor_module_default()).mention,
        children: children
    });
};
var hashtagSpan = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (TextEditor_module_default()).hashtag,
        children: children
    });
};
var OverLimitSpan = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (TextEditor_module_default()).overLimit,
        children: children
    });
};
var hashtagRegedx = (0,utils/* hashTagRegexFactory */.cS)();
var linkRegex = (0,utils/* linkRegexFactory */.EU)();
function hashtagStrategy(contentBlock, callback) {
    findWithRegex(hashtagRegedx, contentBlock, callback);
}
function linkStrategy(contentBlock, callback) {
    findWithRegex(linkRegex, contentBlock, callback);
}
var TextEditor = function(param, ref) {
    var setPlainText = param.setPlainText, placeholder = param.placeholder, onFocus = param.onFocus, readOnly = param.readOnly, _initialText = param.initialText, initialText = _initialText === void 0 ? "" : _initialText, _charLimit = param.charLimit, charLimit = _charLimit === void 0 ? 2000 : _charLimit, mentionTarget = param.mentionTarget, _textPolicies = param.textPolicies, textPolicies = _textPolicies === void 0 ? [] : _textPolicies, _blackUrls = param.blackUrls, blackUrls = _blackUrls === void 0 ? [] : _blackUrls, onEnter = param.onEnter;
    var overLimitStrategy = (0,react.useMemo)(function() {
        return function(contentBlock, callback) {
            var text = contentBlock.getText();
            var len = text.length;
            if (len > charLimit) {
                callback(charLimit, len);
            }
        };
    }, [
        charLimit
    ]);
    var mentionStrategy = (0,react.useMemo)(function() {
        return function(contentBlock, callback) {
            if (!mentionTarget) return;
            var text = contentBlock.getText();
            try {
                var regex = new RegExp("@".concat(mentionTarget.name).replaceAll("(", "\\(").replaceAll(")", "\\)").replaceAll("[", "\\[").replaceAll("*", "\\*").replaceAll("+", "\\+"));
                var matchArr = regex.exec(text);
                if (matchArr !== null) {
                    var start = matchArr.index;
                    callback(start, start + matchArr[0].length);
                }
            // eslint-disable-next-line no-empty
            } catch (e) {}
        };
    }, [
        mentionTarget
    ]);
    var policyStrategy = (0,react.useMemo)(function() {
        return function(contentBlock, callback) {
            if (!textPolicies || textPolicies.length === 0) return;
            var text = contentBlock.getText();
            try {
                textPolicies.forEach(function(policy) {
                    var regex = new RegExp(policy.name);
                    var matchArr = regex.exec(text);
                    if (matchArr !== null) {
                        var start = matchArr.index;
                        callback(start, start + matchArr[0].length);
                    }
                });
            // eslint-disable-next-line no-empty
            } catch (e) {}
        };
    }, [
        textPolicies
    ]);
    var policySpan = (0,react.useCallback)(function(data) {
        var children = data.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (TextEditor_module_default()).policy,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("del", {
                children: children
            })
        });
    }, []);
    var linkSpan = (0,react.useCallback)(function(data) {
        var children = data.children;
        if (!blackUrls || blackUrls.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (TextEditor_module_default()).link,
                children: children
            });
        }
        var text = data.decoratedText;
        var blackUrl = blackUrls.find(function(u) {
            return u.url.includes(text);
        });
        if (!blackUrl) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (TextEditor_module_default()).link,
                children: children
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (TextEditor_module_default()).policy,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("del", {
                children: children
            })
        });
    }, [
        blackUrls
    ]);
    var decorator = (0,react.useMemo)(function() {
        return new Draft.CompositeDecorator([
            {
                strategy: overLimitStrategy,
                component: OverLimitSpan
            },
            {
                strategy: linkStrategy,
                component: linkSpan
            },
            {
                strategy: mentionStrategy,
                component: mentionSpan
            },
            {
                strategy: policyStrategy,
                component: policySpan
            },
            {
                strategy: hashtagStrategy,
                component: hashtagSpan
            }, 
        ]);
    }, [
        overLimitStrategy,
        linkSpan,
        mentionStrategy,
        policyStrategy,
        policySpan
    ]);
    var _$ref = (0,react.useState)(function() {
        return Draft.EditorState.createWithContent(Draft.ContentState.createFromText(initialText), decorator);
    }), editorState = _$ref[0], setEditorState = _$ref[1];
    var selfRef = (0,react.useRef)();
    (0,react.useImperativeHandle)(ref, function() {
        return {
            getContent: function getContent() {
                return editorState.getCurrentContent().getPlainText("");
            },
            setEditorText: function(s) {
                var state = Draft.EditorState.set(Draft.EditorState.createWithContent(Draft.ContentState.createFromText(s)), {
                    decorator: decorator
                });
                setEditorState(state);
            },
            focus: function focus() {
                setEditorState(Draft.EditorState.moveFocusToEnd(editorState));
            },
            reset: function reset() {
                var newState = Draft.EditorState.createEmpty();
                setEditorState(Draft.EditorState.moveFocusToEnd(newState));
            },
            forceRender: function forceRender() {
                var content = editorState.getCurrentContent();
                var currentOffset = editorState.getSelection().getFocusOffset();
                var newEditorState = Draft.EditorState.createWithContent(content, decorator);
                var newSelection = editorState.getSelection().merge({
                    focusOffset: currentOffset,
                    anchorOffset: currentOffset
                });
                setEditorState(Draft.EditorState.acceptSelection(newEditorState, newSelection));
            }
        };
    }, [
        editorState,
        decorator
    ]);
    (0,react.useEffect)(function() {
        var plainText = editorState.getCurrentContent().getPlainText("");
        setPlainText(plainText);
    }, [
        setPlainText,
        editorState
    ]);
    var handleBeforeInput = function(chars, state) {
        try {
            var currentContentState = state.getCurrentContent();
            var selectionState = state.getSelection();
            setEditorState(Draft.EditorState.push(editorState, Draft.Modifier.replaceText(currentContentState, selectionState, chars), "remove-range"));
        // eslint-disable-next-line no-empty
        } catch (error) {}
        return "handled";
    };
    var handleKeyCommand = function(command) {
        if (command === "enter_command") {
            onEnter && onEnter();
            return "handled";
        }
        return "not-handled";
    };
    var myKeyBindingFn = function(e) {
        if (e.key === "Enter" && onEnter) {
            return "enter_command";
        }
        return (0,Draft.getDefaultKeyBinding)(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TextEditor_module_default()).textEditorWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundaryClient, {
            errorHandler: function() {
                var content = editorState.getCurrentContent();
                var currentOffset = editorState.getSelection().getFocusOffset();
                var newEditorState = Draft.EditorState.createWithContent(content, decorator);
                var newSelection = editorState.getSelection().merge({
                    focusOffset: currentOffset,
                    anchorOffset: currentOffset
                });
                setEditorState(Draft.EditorState.acceptSelection(newEditorState, newSelection));
            },
            children: editorState && /*#__PURE__*/ (0,jsx_runtime.jsx)(Draft.Editor, {
                ref: selfRef,
                editorState: editorState,
                onChange: setEditorState,
                placeholder: placeholder,
                spellCheck: true,
                handleKeyCommand: handleKeyCommand,
                keyBindingFn: myKeyBindingFn,
                onFocus: onFocus,
                readOnly: readOnly,
                handleBeforeInput: handleBeforeInput,
                handlePastedText: function(text) {
                    try {
                        var pastedBlocks = Draft.ContentState.createFromText(text).getBlockMap();
                        var newState = Draft.Modifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), pastedBlocks);
                        setEditorState(Draft.EditorState.push(editorState, newState, "insert-fragment"));
                    // eslint-disable-next-line no-empty
                    } catch (error) {}
                    return "handled";
                }
            })
        })
    });
};
// const policyLink = (text: string, url: string): string => {
//   const start = text.indexOf(`[`);
//   const end = text.indexOf(`]`);
//   const linkText = text.substring(start + 1, end);
//   return text.replace(
//     `[${linkText}]`,
//     `<a onclick="window.open('${url}')">${linkText}</a>`
//   );
// };
/* harmony default export */ var common_TextEditor = (/*#__PURE__*/(0,react.forwardRef)(TextEditor));


/***/ }),

/***/ 35711:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"answerItem":"AnswerItemView_answerItem__dZLKw","isSelected":"AnswerItemView_isSelected__kOUc5","isWrong":"AnswerItemView_isWrong__fndqd","isCorrect":"AnswerItemView_isCorrect__zrBdz","answerText":"AnswerItemView_answerText__p2VyX","icon":"AnswerItemView_icon__a1IIY"};

/***/ }),

/***/ 58471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"courseDetailWrapper":"CourseDetails_courseDetailWrapper__yVHT1","courseContentWrapper":"CourseDetails_courseContentWrapper__MdmC2","lectureVideoWrapper":"CourseDetails_lectureVideoWrapper__hD6QB","lectureThumbnail":"CourseDetails_lectureThumbnail__rf_m4","registerBtnWrapper":"CourseDetails_registerBtnWrapper__6DOlU","courseContent":"CourseDetails_courseContent__o5ZrK","courseContentTabs":"CourseDetails_courseContentTabs__uSrfy","tab":"CourseDetails_tab__EdKWb","tabContent":"CourseDetails_tabContent__GITrI","selected":"CourseDetails_selected__8i5k4","tabContentWrapper":"CourseDetails_tabContentWrapper__kFd3y"};

/***/ }),

/***/ 8240:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"courseOverview":"CourseOverview_courseOverview__M_7MU","categories":"CourseOverview_categories__O_0nL","categoryItem":"CourseOverview_categoryItem__e7JVH","courseTitle":"CourseOverview_courseTitle__gjvrJ","blank":"CourseOverview_blank__FlwMY","courseDescription":"CourseOverview_courseDescription__uQpcV","creatorInfoWrapper":"CourseOverview_creatorInfoWrapper__oWajg","ratingSection":"CourseOverview_ratingSection__iHKfh","startCourseButton":"CourseOverview_startCourseButton__HvEQd","infoTitle":"CourseOverview_infoTitle__CvcA4","blankInfo":"CourseOverview_blankInfo__UlKkC","targetCustomer":"CourseOverview_targetCustomer__H0_vu","benefits":"CourseOverview_benefits__Z2LrW","benefit":"CourseOverview_benefit__dNdEn","icon":"CourseOverview_icon__KpkqQ","benefitContent":"CourseOverview_benefitContent__Dv3_N"};

/***/ }),

/***/ 60391:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialogWrapper":"CoursePaymentDialog_dialogWrapper__rVg2B","closeBtn":"CoursePaymentDialog_closeBtn__QVzMR","container":"CoursePaymentDialog_container__pDFX9","formSection":"CoursePaymentDialog_formSection__hJ0Cp","loading":"CoursePaymentDialog_loading__Iv1Z1","header":"CoursePaymentDialog_header___EN5e","subHeader":"CoursePaymentDialog_subHeader__8PFjI","inputGroup":"CoursePaymentDialog_inputGroup__TMBw5","expiry":"CoursePaymentDialog_expiry__2QyST","cvc":"CoursePaymentDialog_cvc__6JAKO","label":"CoursePaymentDialog_label__COGpz","cardInput":"CoursePaymentDialog_cardInput__MjELl","warningText":"CoursePaymentDialog_warningText__lR_eQ","confirmBtn":"CoursePaymentDialog_confirmBtn__wox7J","existingCard":"CoursePaymentDialog_existingCard__JIvGC","ccNumber":"CoursePaymentDialog_ccNumber__fN_5z","title":"CoursePaymentDialog_title__f6pPB","discount":"CoursePaymentDialog_discount__0lAFQ","name":"CoursePaymentDialog_name__o1YI2","line":"CoursePaymentDialog_line__jJcyb","price":"CoursePaymentDialog_price__E2qz3","number":"CoursePaymentDialog_number__Nwuy8","paymentMethodSection":"CoursePaymentDialog_paymentMethodSection__PLD5f"};

/***/ }),

/***/ 25024:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"previewContent":"CoursePreview_previewContent__7flAl","thumbImage":"CoursePreview_thumbImage__57OA_","noThumbText":"CoursePreview_noThumbText__rw4Kk","courseTitle":"CoursePreview_courseTitle__BgAwY","creatorInfo":"CoursePreview_creatorInfo__s3qCj","ratingSection":"CoursePreview_ratingSection__jZF8e","infoTitle":"CoursePreview_infoTitle__8Zjhy","blankInfo":"CoursePreview_blankInfo__M1Ljl","targetCustomer":"CoursePreview_targetCustomer__D26jY","courseDescription":"CoursePreview_courseDescription__sIuB7"};

/***/ }),

/***/ 12147:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputCard":"InputCard_inputCard__oFtGn","inputGroupWrapper":"InputCard_inputGroupWrapper__PvOda","inputGroup":"InputCard_inputGroup__FKA2a","expiry":"InputCard_expiry___hW8q","cvc":"InputCard_cvc__HATjI","label":"InputCard_label__vDKe_","cardInput":"InputCard_cardInput__GbtAX"};

/***/ }),

/***/ 44701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"smallPrint":"PolicyDescription_smallPrint__L0oIP","link":"PolicyDescription_link__8l7uX"};

/***/ }),

/***/ 98237:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lecturesMenuWrapper":"LecturesMenu_lecturesMenuWrapper__SkGnx","lecturesMenu":"LecturesMenu_lecturesMenu__W4mVH","menuTop":"LecturesMenu_menuTop__AoQac","courseTitle":"LecturesMenu_courseTitle__cuiwW","purchaseInfo":"LecturesMenu_purchaseInfo__p5yYL","openPaywallButton":"LecturesMenu_openPaywallButton__5YtWh","courseTotalInfo":"LecturesMenu_courseTotalInfo__wXiW1","lecturesCount":"LecturesMenu_lecturesCount__fvwX1","minutes":"LecturesMenu_minutes__jXPW4","lecturesList":"LecturesMenu_lecturesList__tB_bV","lectureItem":"LecturesMenu_lectureItem__6EUuF","currentItem":"LecturesMenu_currentItem__wL34F","lectureStatus":"LecturesMenu_lectureStatus___1KcP","doing":"LecturesMenu_doing__uPSJP","notYet":"LecturesMenu_notYet__Tqbpq","lectureType":"LecturesMenu_lectureType__nLCuk","lectureInfo":"LecturesMenu_lectureInfo__dhFpr","lectureTitleWrapper":"LecturesMenu_lectureTitleWrapper__iwgl5","lectureIndex":"LecturesMenu_lectureIndex__qh6IA","lectureTitle":"LecturesMenu_lectureTitle__E_uIX","lectureDuration":"LecturesMenu_lectureDuration__T7KDR","durationWrapper":"LecturesMenu_durationWrapper__isEjE","icon":"LecturesMenu_icon__egvLC","number":"LecturesMenu_number__FCr8j","viewCount":"LecturesMenu_viewCount__TS50h"};

/***/ }),

/***/ 54959:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"results":"AnswersResult_results__EcD81","title":"AnswersResult_title__5yOiH","questionResultItem":"AnswersResult_questionResultItem__QGy_t","questionDetail":"AnswersResult_questionDetail__dubhe","notAnswerYet":"AnswersResult_notAnswerYet__Uzvbt"};

/***/ }),

/***/ 78837:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialogWrapper":"QuestionsAnswerDialog_dialogWrapper__cozRV","closeBtn":"QuestionsAnswerDialog_closeBtn__GZJLU","container":"QuestionsAnswerDialog_container__pI5s8","questionsCount":"QuestionsAnswerDialog_questionsCount__xRUB4","actions":"QuestionsAnswerDialog_actions__H0SrO","currentQuestionWrapper":"QuestionsAnswerDialog_currentQuestionWrapper__X8mCX","questionDetail":"QuestionsAnswerDialog_questionDetail__RoGlX","alertText":"QuestionsAnswerDialog_alertText__iE5FO","answersList":"QuestionsAnswerDialog_answersList___LbaU"};

/***/ }),

/***/ 85425:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addReviewSection":"ReviewCommentBox_addReviewSection__ibkEi","title":"ReviewCommentBox_title__TI7ob","addRatingSection":"ReviewCommentBox_addRatingSection__UHjc_","addReviewButton":"ReviewCommentBox_addReviewButton__5c48J","commentBox":"ReviewCommentBox_commentBox__ujgxb","inputBox":"ReviewCommentBox_inputBox__WpjKa","textInputWrapper":"ReviewCommentBox_textInputWrapper__tObh2","footer":"ReviewCommentBox_footer__zBKVx","textInput":"ReviewCommentBox_textInput__x0e80","rightSide":"ReviewCommentBox_rightSide__EafTO","progress":"ReviewCommentBox_progress__UUz7H"};

/***/ }),

/***/ 86013:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"postCommentWrapper":"ReviewItem_postCommentWrapper__t_iC3","userInfo":"ReviewItem_userInfo__nOahP","avatar":"ReviewItem_avatar__3bcNF","nameJob":"ReviewItem_nameJob__nqar6","userNameText":"ReviewItem_userNameText__bgpb3","userJobText":"ReviewItem_userJobText__AU_VT","badge":"ReviewItem_badge__akbdR","membershipIcon":"ReviewItem_membershipIcon__HUps6","contentBox":"ReviewItem_contentBox__09U0j","content":"ReviewItem_content__nCZxQ","tinyMode":"ReviewItem_tinyMode__DNCM1","footerActions":"ReviewItem_footerActions__lgF8h","icon":"ReviewItem_icon__PPzRo","number":"ReviewItem_number__N2Gk7","liked":"ReviewItem_liked__9AV7L","timeSince":"ReviewItem_timeSince__HzaPT","repliesTitle":"ReviewItem_repliesTitle__si0ZE","replies":"ReviewItem_replies__4JsRu","reply":"ReviewItem_reply__r_2xk","more":"ReviewItem_more__YJL_A"};

/***/ }),

/***/ 11854:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reviewSection":"ReviewSection_reviewSection__6Q8x9","reviewSectionTitle":"ReviewSection_reviewSectionTitle__3sEww","reviewsListTitle":"ReviewSection_reviewsListTitle__RM3FD","courseRatingSection":"ReviewSection_courseRatingSection__xzkfi","ratingSummary":"ReviewSection_ratingSummary__h_PyV","ratingNumber":"ReviewSection_ratingNumber__oenM_","reviewsCount":"ReviewSection_reviewsCount__Khbb6","ratingDetailsSection":"ReviewSection_ratingDetailsSection__iYdgm","ratingDetailItem":"ReviewSection_ratingDetailItem__7g8Ta","rating":"ReviewSection_rating___qzhD","progressBar":"ReviewSection_progressBar__77SPx","offOverlay":"ReviewSection_offOverlay__kpAzO","in-out":"ReviewSection_in-out__FGyJY","fullWidth":"ReviewSection_fullWidth__zY0Jv","addReviewBox":"ReviewSection_addReviewBox__WwqGz","reviewsListWrapper":"ReviewSection_reviewsListWrapper__Nc3Ru","empty":"ReviewSection_empty__lk6lX"};

/***/ }),

/***/ 18685:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"speedCtrl":"PlayerRateOptions_speedCtrl__2Or65","speedCtrlOptions":"PlayerRateOptions_speedCtrlOptions__kppiq","speedBtn":"PlayerRateOptions_speedBtn__e_LsE","text":"PlayerRateOptions_text__ZFp7M","content":"PlayerRateOptions_content__VXKku","isWhite":"PlayerRateOptions_isWhite__pEJ32","icon":"PlayerRateOptions_icon__dfaKS","isMembership":"PlayerRateOptions_isMembership__XQv_j","isVip":"PlayerRateOptions_isVip__DV327"};

/***/ }),

/***/ 53637:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"ViewLectureVideoPlayer_playerWrapper__peym2","fullscreenVideo":"ViewLectureVideoPlayer_fullscreenVideo__beBMi","answerButtonOverlay":"ViewLectureVideoPlayer_answerButtonOverlay__7Ar6d","endOfLectureTitle":"ViewLectureVideoPlayer_endOfLectureTitle__Qp0RI","answerDescription":"ViewLectureVideoPlayer_answerDescription__LdsEI","answerButton":"ViewLectureVideoPlayer_answerButton__ig_EQ","rewindButton":"ViewLectureVideoPlayer_rewindButton__FcZIW","playerOverlay":"ViewLectureVideoPlayer_playerOverlay__5_6GA","addChapterInVideoWrapper":"ViewLectureVideoPlayer_addChapterInVideoWrapper__eSEpK","mediaControlBtn":"ViewLectureVideoPlayer_mediaControlBtn__wQSwg","pauseBtn":"ViewLectureVideoPlayer_pauseBtn__yg_G5","skipBtn":"ViewLectureVideoPlayer_skipBtn__TFh_z","centerBtn":"ViewLectureVideoPlayer_centerBtn__T0yCP","replayWrapper":"ViewLectureVideoPlayer_replayWrapper__lvGpJ","replayText":"ViewLectureVideoPlayer_replayText__e9jeO","playWrapper":"ViewLectureVideoPlayer_playWrapper__SuxzH","leftCorner":"ViewLectureVideoPlayer_leftCorner__khFVj","mobileCtrlLeftCorner":"ViewLectureVideoPlayer_mobileCtrlLeftCorner__rvPj8","playTime":"ViewLectureVideoPlayer_playTime__R6F0y","timebar":"ViewLectureVideoPlayer_timebar__rNnkV","sliderTime":"ViewLectureVideoPlayer_sliderTime__kyqtj","rightCorner":"ViewLectureVideoPlayer_rightCorner__4Ox6T","volumeCtrl":"ViewLectureVideoPlayer_volumeCtrl__FUwhs","volumeSlider":"ViewLectureVideoPlayer_volumeSlider__17slS","speakerBtn":"ViewLectureVideoPlayer_speakerBtn__nMCw3","fullscreenBtn":"ViewLectureVideoPlayer_fullscreenBtn__g0wLN","fullscreenText":"ViewLectureVideoPlayer_fullscreenText__4LAfj","chaptersListWrapper":"ViewLectureVideoPlayer_chaptersListWrapper__UAFJA","nextBtn":"ViewLectureVideoPlayer_nextBtn__q1Ke0","backBtn":"ViewLectureVideoPlayer_backBtn__SzKAi","chaptersListHeader":"ViewLectureVideoPlayer_chaptersListHeader__Z_dn0","chaptersList":"ViewLectureVideoPlayer_chaptersList__lqJL1","chapterItem":"ViewLectureVideoPlayer_chapterItem__7A3Y2","currentItem":"ViewLectureVideoPlayer_currentItem__jXhIt","chapterThumbnail":"ViewLectureVideoPlayer_chapterThumbnail__2QwDt","chapterTitle":"ViewLectureVideoPlayer_chapterTitle__X6PXZ","chapterStartPosition":"ViewLectureVideoPlayer_chapterStartPosition__acCI4","fullscreen":"ViewLectureVideoPlayer_fullscreen__N0Bv3"};

/***/ }),

/***/ 76891:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ratingSection":"CourseRatingView_ratingSection__ERSMD","rateValue":"CourseRatingView_rateValue__5OUj5","ratingCount":"CourseRatingView_ratingCount__K9Gl_"};

/***/ }),

/***/ 88821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ring":"ProgressRing_ring__hzLnO","text":"ProgressRing_text__4Acs_","overflow":"ProgressRing_overflow__ADdSW"};

/***/ }),

/***/ 54681:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"richContentWrapper":"RichContent_richContentWrapper__CqUEb","mention":"RichContent_mention__spBez","hashtag":"RichContent_hashtag__ZRc29","email":"RichContent_email__0ipH3","special":"RichContent_special__QvHef","link":"RichContent_link__RRYeT"};

/***/ }),

/***/ 47098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialogWrapper":"TeenagePaymentAlertPopup_dialogWrapper__CtEA3","title":"TeenagePaymentAlertPopup_title__X7AkA","subTitle":"TeenagePaymentAlertPopup_subTitle__kd3Gu","footer":"TeenagePaymentAlertPopup_footer__uCniw","policy":"TeenagePaymentAlertPopup_policy__jRndc"};

/***/ }),

/***/ 21086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textEditorWrapper":"TextEditor_textEditorWrapper__Fvnka","mention":"TextEditor_mention__TxHDC","hashtag":"TextEditor_hashtag__zKuTV","link":"TextEditor_link__dizTP","overLimit":"TextEditor_overLimit__bveki","policy":"TextEditor_policy__5iQoT","description":"TextEditor_description__sEoGK","content":"TextEditor_content__CddCv"};

/***/ })

}]);